export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-06-13T12:36:58.031Z",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "",
        "10": "",
        " - element testowy, zawierający pytania jednokrotnego lub wielokrotnego wyboru.": "",
        " - element zawierający slajdy opisowe, czyli treści podawcze; można określić liczbę slajdów.).": "",
        " - główny element grupujący (np. rozdział lub sekcja szkolenia).": "",
        " dodanych w ": "",
        " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": "",
        " godz.": "",
        " opublikowanych": "",
        " użytkowników.": "",
        "-": "",
        "...": "",
        "...nie znalazłeś bloku?": "",
        "...nie znalazłeś bloku? Dodaj nowy.": "",
        "' + file.filename + '": "",
        "' + func.name + '": "",
        "' + option.name + '": "",
        "{Potwierdzenie przywrócenia": "",
        "%$ – znacznik otwierający tag": "",
        "%0": "",
        "%0 z %1": "",
        "%0 znaków": "",
        "<Brak nazwy>": "",
        "${copied ? 'Skopiowano' : 'Kopiuj'}": "",
        "${el.text}": "",
        "${form.variants > 1 ? 'Generuj obrazy' : 'Generuj obraz'}": "",
        "${getCurrentScope().label}": "",
        "${item.entityName}": "",
        "${item.name}": "",
        "${item.text}": "",
        "${props.inputPlaceholder}": "",
        "${str}": "",
        "${tokenVisibility ? 'Ukryj' : 'Pokaż'} token": "",
        "${widget.name}": "",
        "$% - znacznik zamykający tag": "",
        "1 godzina": "",
        "1:1": "",
        "10 minut": "",
        "12 godzin": "",
        "15 minut": "",
        "1K tokenów": "",
        "1M tokenów": "",
        "2 dni": "",
        "2 miesiące": "",
        "2 tygodnie": "",
        "24 godziny": "",
        "3 dni": "",
        "3 godziny": "",
        "3 miesiące": "",
        "30 minut": "",
        "4 dni": "",
        "4:7": "",
        "5 dni": "",
        "5 minut": "",
        "6 dni": "",
        "6 godzin": "",
        "7:4": "",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do terminu musisz najpierw zapisać formularz.": "",
        "Aby dodawać użytkowników do wydarzenia musisz najpierw zapisać formularz.": "",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "",
        "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "",
        "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "",
        "Aby móc korzystać z czatu, wybierz asystenta z listy i oznacz go jako głównego asystenta panelu.": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Aby móc zapisać element szkolenia, powinien on posiadać przynajmniej jeden opublikowany slajd.": "",
        "Aby połączenie z API OpenAI zostało nawiązane, należy podać klucz wygenerowany na stronie producenta i wybrać wersję modelu. Połączenie z API jest sprawdzane przy zapisie formularza.": "",
        "Aby uzyskać najlepsze rezultaty, zalecamy stosowanie poniższych wskazówek podczas definiowania prompta dla kreatora szkoleń AI.": "",
        "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "",
        "Adaptive sampling": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Miasta": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Województwa": "",
        "Administracja - Zespoły": "",
        "Administratorzy": "",
        "Adres": "",
        "Adres API": "",
        "Adres docelowy": "",
        "Adres domenowy": "",
        "Adres domeny": "",
        "Adres e-mail potwierdzony": "",
        "Adres email": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres IP: %0": "",
        "Adres kanoniczny": "",
        "Adres serwera": "",
        "Adres strony": "",
        "Adres url": "",
        "Adres URL": "",
        "Adres url do pliku wideo": "",
        "Adres URL profilu autora.": "",
        "Adres URL Webinaru": "",
        "Adres źródłowy": "",
        "Adresy email": "",
        "Akcent": "",
        "Akceptacja": "",
        "Akceptacja dokumentów": "",
        "Akceptacja dokumentu": "",
        "Akceptacja komentarzy": "",
        "Akceptacja własnych dokumentów": "",
        "Akceptacja wszystkich dokumentów": "",
        "Akceptowalny typ plików": "",
        "Akceptowany format danych": "",
        "Akceptuj": "",
        "Akcja": "",
        "Akcja zakończona niepowodzeniem dla: ": "",
        "Akcje": "",
        "Akordeon": "",
        "Aktualizacja definicji": "",
        "Aktualizacja pkiów Kreatora szkoleń nie powiodła się": "",
        "Aktualizacja wpisu": "",
        "Aktualizacja wyników szkolenia użytkowników została dodana do kolejki zadań.": "",
        "Aktualizacja: {0}": "",
        "Aktualizuj": "",
        "Aktualizuj wątek": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktualne urządzenie": "",
        "Aktualności": "",
        "Aktualności ze strony": "",
        "Aktualny": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne kanały komunikacji": "",
        "Aktywne sesje": "",
        "Aktywne teraz": "",
        "Aktywne źródła": "",
        "Aktywni": "",
        "Aktywność": "",
        "Aktywny": "",
        "Aktywuj AI": "",
        "Aktywuj inteligentne usługi oparte o sztuczną inteligencję.": "",
        "Aktywuj tłumaczenia": "",
        "Aktywuj zestaw inteligentnych narzędzi": "",
        "Alert": "",
        "Alfabetycznie": "",
        "Alias": "",
        "Alias został przepięty.": "",
        "Angielski": "",
        "Ankieta": "",
        "Ankieta po szkoleniu": "",
        "Ankieta po szkoleniu jest już nieaktualna.": "",
        "Ankieta przed i po szkoleniu": "",
        "Ankieta przed szkoleniem": "",
        "Ankieta przed szkoleniem jest już nieaktualna.": "",
        "Ankiety": "",
        "Anonimizuj": "",
        "Anonimowy": "",
        "Anulowany": "",
        "Anuluj": "",
        "Anuluj edycję": "",
        "Anuluj wszystkie wprowadzone zmiany": "",
        "Aplikacja": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "Apple iPad": "",
        "Apple iPhone 5": "",
        "Apple iPhone 6": "",
        "Application Insights": "",
        "application/json": "",
        "application/x-www-form-urlencoded": "",
        "Aranżacja": "",
        "Aranżacja alternatywna": "",
        "Aranżacja domyślna": "",
        "Aranżacja główna": "",
        "Aranżacja utowrzona przez": "",
        "Aranżacja została dodana.": "",
        "Aranżacja została opublikowana.": "",
        "Aranżacja została usunięta.": "",
        "Aranżacja została zachowana.": "",
        "Aranżacja została zaktualizowana.": "",
        "Aranżacje": "",
        "Archiwalne elementy szkolenia": "",
        "Archiwizuj": "",
        "Archiwizuj materiał lekcji": "",
        "Archiwizuj materiał testu": "",
        "Archiwizuj przez maksymalnie (dni)": "",
        "Archiwizuj stronę": "",
        "Archiwum": "",
        "Artykuł": "",
        "Artykuł otwarty": "",
        "Artykuł premium": "",
        "Artykuł Premium": "",
        "Artykuł sponsorowany": "",
        "Artykuły": "",
        "Artykuły ze statusem PRIORYTET": "",
        "Asystenci": "",
        "Asystent": "",
        "Asystent AI": "",
        "Asystent główny": "",
        "Asystent został dodany.": "",
        "Asystent został usunięty.": "",
        "Asystent został zaktualizowany.": "",
        "Asystenta AI": "",
        "Audio": "",
        "Audio z biblioteki": "",
        "Automatyczna akceptacja": "",
        "Automatyczna akceptacja komentarzy zalogowanych użytkowników": "",
        "Automatyczna akceptacja wszystkich komentarzy": "",
        "Automatyczna publikacja galerii": "",
        "Automatyczne akceptacja wersji po osiągnięciu daty publikacji. Wybrana wersja musi mieć ustawiony status na \"Ukończony\"": "",
        "Automatyczny": "",
        "Automatyzacja": "",
        "Autor": "",
        "Autor nie może zostać usunięty, ponieważ jest przypisany do artykułów": "",
        "Autor spotkania": "",
        "Autor szkolenia": "",
        "Autor został dodany.": "",
        "Autor został usunięty.": "",
        "Autor został zaktualizowany.": "",
        "Autor/adres IP": "",
        "Autorzy": "",
        "Autorzy spoza bazy użytkowników": "",
        "Azure": "",
        "Azure AD": "",
        "Azure AI": "",
        "Azure Application Insights": "",
        "Azure OpenAI": "",
        "Barwa tekstu": "",
        "Barwa tła": "",
        "Basic Auth": "",
        "Baza danych": "",
        "Baza danych tego klienta jest nieaktualna.": "",
        "Baza dokumentów": "",
        "Bazowy model danych": "",
        "Bazy danych": "",
        "Bez \"http(s)://\" i \"/\" na końcu.": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Bezpieczny adres URL": "",
        "Biały": "",
        "Biblioteka": "",
        "Bieżący dokument": "",
        "Blok aktywny": "",
        "Blok unikalny może zostać użyty tylko raz": "",
        "Blok został usunięty.": "",
        "Blokada konta": "",
        "Blokada konta do": "",
        "Bloki": "",
        "Blokowanie kont": "",
        "Blokowanie użytkowników": "",
        "Blokowanie użytkowników szkoleń": "",
        "Błąd": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błąd w kolumnie ${error.columnName} w wierszu ${error.actualRow} - ${error.error}": "",
        "Błędne": "",
        "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "",
        "Błędny": "",
        "Błędny format adresu e-mail": "",
        "Błędy": "",
        "Błędy walidacji należy przypisać do \"entry.errors.value\" w postaci tablicy komunikatów.": "",
        "Bool": "",
        "brak": "",
        "Brak": "",
        "Brak artykułów": "",
        "Brak cennika dla wybranego dostawcy.": "",
        "Brak danych": "",
        "Brak dodanych kolumn": "",
        "Brak dodanych plików": "",
        "Brak dostępu do szkoleń": "",
        "Brak elementów": "",
        "Brak etykiety": "",
        "Brak kategorii": "",
        "Brak kategorii nadrzędnej": "",
        "Brak kluczy": "",
        "Brak kolekcji": "",
        "Brak listy regulaminów": "",
        "Brak materiałów": "",
        "Brak modułu": "",
        "Brak możliwości zmiany spotkania po utworzeniu terminu.": "",
        "Brak nowych powiadomień.": "",
        "Brak odpowiedzi": "",
        "Brak ograniczenia": "",
        "Brak opcji": "",
        "Brak opisu": "",
        "Brak plików do dodania": "",
        "Brak powiązania ze szkoleniem": "",
        "Brak powiązań": "",
        "Brak produktów w kolekcji": "",
        "Brak stron": "",
        "Brak strony nadrzędnej": "",
        "Brak tematu": "",
        "Brak typu zadania": "",
        "Brak uprawnień do zaliczania elementów.": "",
        "Brak wersji": "",
        "Brak wyboru": "",
        "brak wyboru...": "",
        "Brak wybranych autorów": "",
        "Brak wyników": "",
        "Brak zdefiniowanych ról.": "",
        "Brak zdefiniowanych zespołów.": "",
        "Brakujące tytuły kafelków.": "",
        "Bramka SMS": "",
        "Browse files": "",
        "Browse links": "",
        "Build": "",
        "Cache": "",
        "Cache będzie przechowywany z wykorzystaniem serwera Redis.": "",
        "Cache po stronie serwera": "",
        "Cache-Control": "",
        "Cechy": "",
        "Cel aktywny": "",
        "Cel został dodany.": "",
        "cel został usunięty.": "",
        "Cel został zaktualizowany.": "",
        "Cele": "",
        "Cena": "",
        "Cena brutto": "",
        "Cena netto": "",
        "Cena netto - aktualna": "",
        "Cena netto - najniższa z ostatnich 30 dni": "",
        "Cena netto - regularna": "",
        "Cena w dolarach sumy tokenów wejściowych i wyjściowych.": "",
        "Cennik Azure OpenAI": "",
        "Cennik AzureAI": "",
        "Cennik OpenAI": "",
        "Centrum powiadomień": "",
        "Certyfikat": "",
        "Certyfikat jest opublikowany": "",
        "Certyfikat nie jest opublikowany": "",
        "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "",
        "Certyfikat został dodany.": "",
        "Certyfikat został usunięty.": "",
        "Certyfikat został zaktualizowany.": "",
        "Certyfikat-podgląd": "",
        "Certyfikatów": "",
        "Certyfikaty": "",
        "Chat": "",
        "Chcesz przywrócić temat wraz z elementami?": "",
        "Chcesz przywrócić ten element?": "",
        "Checkbox": "",
        "Choices": "",
        "Ciemny": "",
        "Cienka": "",
        "Client ID": "",
        "Client Secret": "",
        "CMS": "",
        "co": "",
        "Co 10 dni": "",
        "Co 10 minut": "",
        "Co 12 godzin": "",
        "Co 15 minut": "",
        "Co 2 godziny": "",
        "Co 2 minuty": "",
        "Co 2 tygodnie": "",
        "Co 20 minut": "",
        "Co 3 godziny": "",
        "co 3 miesiące": "",
        "Co 3 miesiące": "",
        "co 30 dni": "",
        "Co 30 minut": "",
        "Co 4 miesiące": "",
        "Co 5 dni": "",
        "Co 5 minut": "",
        "Co 6 godzin": "",
        "co 6 miesięcy": "",
        "Co chcesz wygenerować?": "",
        "Co drugi dzień": "",
        "Co drugi miesiąc": "",
        "Co godzinę": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co pół roku": "",
        "co rok": "",
        "Co rok": "",
        "Co tydzień": "",
        "Codziennie": "",
        "Connection String": "",
        "Coś poszło nie tak": "",
        "CRC": "",
        "Created": "",
        "Cron": "",
        "Cyfry": "",
        "Cykliczne": "",
        "Cykliczność": "",
        "Cytat": "",
        "Cytaty": "",
        "Czarny": "",
        "Czas": "",
        "Czas dostępu do szkolenia (liczba dni)": "",
        "Czas dostępu do ścieżki (liczba dni)": "",
        "Czas na realizację szkolenia (liczba dni)": "",
        "Czas na realizację ścieżki (liczba dni)": "",
        "Czas na slajd": "",
        "Czas na stronie": "",
        "Czas nieaktywności użytkownika po którym zostanie wylogowany z panelu administracyjnego [min": "",
        "Czas pomiędzy": "",
        "Czas rozpoczęcia": "",
        "Czas trwania": "",
        "Czas trwania blokady": "",
        "Czas trwania: %0": "",
        "Czas uruchomienia": "",
        "Czas ważności certyfikatu (liczba dni)": "",
        "Czas zakończenia": "",
        "Czat z asystentem": "",
        "czerwcu": "",
        "czerwiec": "",
        "Czerwiec": "",
        "Czerwony": "",
        "Częstotliwość odświeżania": "",
        "Członkowie zespołu": "",
        "Czołówka": "",
        "Czołówka została dodana.": "",
        "Czołówka została usunięta.": "",
        "Czołówka została zaktualizowana.": "",
        "Cztery kolumny": "",
        "Czwartek": "",
        "Czy aby na pewno chesz przywrócić ustawienia domyślne?": "",
        "Czy aby na pewno chesz zrestartować aplikacje?": "",
        "Czy chcesz wygenerować plan szkolenia?": "",
        "Czy chcesz wygenerować szkolenie na podstawie aktualnego planu?": "",
        "Czy na pewno chcesz ukryć wiadomość?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Czy na pewno chcesz wyczyścić pamięć podręczną?": "",
        "Czy na pewno chcesz zablokować użytkownika?": "",
        "Czy na pewno chcesz zaktualizować definicje wszystkich dokumentów?": "",
        "Czy na pewno chcesz zkopiować szkolenie?": "",
        "Czy opublikowany": "",
        "Czy zablokować użytkownika i jego wiadomość?": "",
        "Czytać mogą tylko zalogowani użytkownicy": "",
        "Dalej": "",
        "DALL-E 3": "",
        "DALLE-3": "",
        "Dane": "",
        "Dane formularza są przechowywane w obiekcie Entry.": "",
        "Dane osobowe": "",
        "Dane tabelaryczne": "",
        "Dane wejściowe": "",
        "Dane wyjściowe": "",
        "Dane z formularza zapisywane anonimowo": "",
        "Dashboard": "",
        "Dashboard aktywny": "",
        "Dashboard domyślny": "",
        "Dashboard szkolenia": "",
        "Dashboard został dodany.": "",
        "Dashboard został skopiowany.": "",
        "Dashboard został usunięty.": "",
        "Dashboard został zaktualizowane.": "",
        "Dashboardy": "",
        "Data": "",
        "Data akceptacji": "",
        "Data automatycznej akceptacji": "",
        "Data dezaktywacji": "",
        "Data do": "",
        "Data dodania": "",
        "Data i czas": "",
        "Data informująca o terminie wejścia w życie tego regulaminu.": "",
        "Data końcowa": "",
        "Data logowania": "",
        "Data modyfikacji": "",
        "Data modyfikacji do": "",
        "Data modyfikacji od": "",
        "Data modyfikacji:": "",
        "Data od": "",
        "Data odrzucenia": "",
        "Data odrzucenia:": "",
        "Data opuszczenia zespołu": "",
        "Data ostatniej aktualizacji danych": "",
        "Data ostatniej edycji": "",
        "Data otrzymania": "",
        "Data otrzymania punktów": "",
        "Data otrzymania punktów do": "",
        "Data otrzymania punktów od": "",
        "Data publikacji": "",
        "Data publikacji:": "",
        "Data rejestracji": "",
        "Data rezygnacji": "",
        "Data rezygnacji do": "",
        "Data rezygnacji od": "",
        "Data rozpoczęcia": "",
        "Data rozpoczęcia spotkania od": "",
        "Data subskrypcji": "",
        "Data uruchomienia": "",
        "Data uruchomienia (UTC)": "",
        "Data usunięcia": "",
        "Data utworzenia": "",
        "Data utworzenia (do)": "",
        "Data utworzenia (od)": "",
        "Data utworzenia aranżacji": "",
        "Data utworzenia wersji": "",
        "Data utworzenia: ": "",
        "Data uzyskania certyfikatu": "",
        "Data uzyskania do": "",
        "Data uzyskania od": "",
        "Data użycia": "",
        "Data wydania": "",
        "Data wygaśnięcia": "",
        "Data wylogowania": "",
        "Data wysłania": "",
        "Data wywołania": "",
        "Data zakończenia": "",
        "Data zakończenia zapisów do": "",
        "Data zakończenia zapisów od": "",
        "Data zakończenia zapisów: ": "",
        "Data zakónczenia spotkania do": "",
        "Data zaliczenia": "",
        "Data zalogowania": "",
        "Data zapisania się": "",
        "Data zapisania się do": "",
        "Data zapisania się od": "",
        "Data zapisu": "",
        "Data zapytania": "",
        "Data zdarzenia": "",
        "Data zgłoszenia": "",
        "Data: %0 | Status: %1": "",
        "DateTime": "",
        "Daty dostępów dla użytkowników ze ścieżki szkoleniowej są nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "",
        "Daty publikacji zostały zaktualizowane.": "",
        "Debug": "",
        "Dedykowane": "",
        "DeepL": "",
        "Definicja": "",
        "Definicja (JSON)": "",
        "Definicja formularza znajduje się w obiekcie Form.": "",
        "Definicja szablonu": "",
        "Definicje zostały zaktualizowane.": "",
        "DELETE: Usunięcie wpisu": "",
        "Design Studio": "",
        "Diagram": "",
        "Długi tekst": "",
        "Długość": "",
        "Długość [%": "",
        "Długość czasu przechowywania": "",
        "Długość geograficzna": "",
        "Długość historii haseł": "",
        "Długość treści": "",
        "Długość trwania sesji (min)": "",
        "Dni": "",
        "Dni i godziny": "",
        "do": "",
        "Do": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Do poziomu": "",
        "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "",
        "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "",
        "Do terminu nie przypisano jeszcze żadnych użytkowników.": "",
        "Docelowa strona": "",
        "Docs": "",
        "Dodaj": "",
        "Dodaj aranżację": "",
        "Dodaj asystenta": "",
        "Dodaj autora": "",
        "Dodaj cel": "",
        "Dodaj certyfikat": "",
        "Dodaj czołówkę": "",
        "Dodaj dashboard": "",
        "Dodaj dni": "",
        "Dodaj do zespołu": "",
        "Dodaj do zestawu": "",
        "Dodaj dokument": "",
        "Dodaj dział": "",
        "Dodaj element": "",
        "Dodaj endpoint": "",
        "Dodaj etykietę": "",
        "Dodaj formularz": "",
        "Dodaj funkcję": "",
        "Dodaj galerię": "",
        "Dodaj grupę": "",
        "Dodaj jeden lub więcej widgetów, aby uzyskać wgląd w postępy swojego zespołu.": "",
        "Dodaj kafelek": "",
        "Dodaj katalog": "",
        "Dodaj kategorie": "",
        "Dodaj kategorię": "",
        "Dodaj klienta": "",
        "Dodaj kolejne słowo": "",
        "Dodaj kolejny powód": "",
        "Dodaj kolekcję": "",
        "Dodaj komponent": "",
        "Dodaj lekcję": "",
        "Dodaj lekcję SCORM": "",
        "Dodaj lekcję Wideo": "",
        "Dodaj link": "",
        "Dodaj materiał": "",
        "Dodaj moduł": "",
        "Dodaj mp3": "",
        "Dodaj nowa kategorię": "",
        "Dodaj nową opinie": "",
        "Dodaj nową wersję dokumentu": "",
        "Dodaj nową witrynę aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy": "",
        "Dodaj nowy folder": "",
        "Dodaj nowy katalog aby rozpocząć zarządzanie stronami.": "",
        "Dodaj nowy tag": "",
        "Dodaj nowy wątek": "",
        "Dodaj obrazek": "",
        "Dodaj odpowiedź": "",
        "Dodaj odznakę": "",
        "Dodaj opinię": "",
        "Dodaj paczkę SCORM": "",
        "Dodaj parametr": "",
        "Dodaj plik": "",
        "Dodaj pliki": "",
        "Dodaj pliki asystenta": "",
        "Dodaj podsumowanie": "",
        "Dodaj powiadomienie zbiorowe": "",
        "Dodaj pozycję": "",
        "Dodaj produkt": "",
        "Dodaj przekierowanie": "",
        "Dodaj punkt": "",
        "Dodaj punkty": "",
        "Dodaj pytanie": "",
        "Dodaj regułe": "",
        "Dodaj rolę": "",
        "Dodaj rotator": "",
        "Dodaj scenariusz": "",
        "Dodaj sekcję": "",
        "Dodaj serwer": "",
        "Dodaj shortcode": "",
        "Dodaj slajd": "",
        "Dodaj slajder": "",
        "Dodaj słowo": "",
        "Dodaj sposób płatności": "",
        "Dodaj spotkanie": "",
        "Dodaj stanowisko": "",
        "Dodaj stronę": "",
        "Dodaj stwierdzenie": "",
        "Dodaj synonimy": "",
        "Dodaj szablon": "",
        "Dodaj szkolenie": "",
        "Dodaj ścieżkę": "",
        "Dodaj temat": "",
        "Dodaj termin": "",
        "Dodaj test": "",
        "Dodaj token": "",
        "Dodaj użytkownika": "",
        "Dodaj wątek": "",
        "Dodaj webhooka": "",
        "Dodaj wideo": "",
        "Dodaj widget": "",
        "Dodaj wiersz": "",
        "Dodaj witrynę": "",
        "Dodaj wpis": "",
        "Dodaj wszystkie z kategorii": "",
        "Dodaj wydarzenie": "",
        "Dodaj zamówienie": "",
        "Dodaj zastępstwo": "",
        "Dodaj zespół": "",
        "Dodaj zestaw": "",
        "Dodaj źródło": "",
        "dodał": "",
        "dodane i edytowane przeze mnie": "",
        "Dodane pliki z sortowaniem": "",
        "Dodane przez": "",
        "Dodane przez moje zespoły": "",
        "Dodane przeze mnie": "",
        "Dodanie": "",
        "Dodanie aktualności": "",
        "Dodanie ankiety": "",
        "Dodanie aranżacji": "",
        "Dodanie artykułu": "",
        "Dodanie asystenta": "",
        "Dodanie autora": "",
        "Dodanie certyfikatu": "",
        "Dodanie czołówki": "",
        "Dodanie dashboardu": "",
        "Dodanie dokumentu": "",
        "Dodanie działu": "",
        "Dodanie endpointu": "",
        "Dodanie etykiety": "",
        "Dodanie funkcji": "",
        "Dodanie galerii": "",
        "Dodanie kategorii": "",
        "Dodanie kategorii wydarzenia": "",
        "Dodanie klienta": "",
        "Dodanie kolekcji": "",
        "Dodanie komponentu": "",
        "Dodanie lekcji": "",
        "Dodanie linku": "",
        "Dodanie modułu": "",
        "Dodanie opcji płatności": "",
        "Dodanie paczki SCORM": "",
        "Dodanie pliku": "",
        "Dodanie poradnika": "",
        "Dodanie produktu": "",
        "Dodanie regulaminu": "",
        "Dodanie roli": "",
        "Dodanie rotatora": "",
        "Dodanie serwera": "",
        "Dodanie slajdera": "",
        "Dodanie slajdów": "",
        "Dodanie spotkania": "",
        "Dodanie stanowiska": "",
        "Dodanie strony": "",
        "Dodanie szablonu": "",
        "Dodanie szkolenia": "",
        "Dodanie ścieżki szkoleniowej": "",
        "Dodanie terminu": "",
        "Dodanie testu": "",
        "Dodanie top tematu": "",
        "Dodanie użytkownika": "",
        "Dodanie webhooka": "",
        "Dodanie wideo": "",
        "Dodanie witryny": "",
        "Dodanie wydarzenia": "",
        "Dodanie wyzwalacza jest wymagane.": "",
        "Dodanie zamówienia": "",
        "Dodanie zastępstwa": "",
        "Dodanie zespołu": "",
        "Dodanie zestawu regulaminów": "",
        "Dodanie źródła": "",
        "Dodanie źródła danych": "",
        "Dodano za dużo plików (maksymalnie %0).": "",
        "dodany": "",
        "Dodanych plików %0 (limit wynosi %1).": "",
        "Dodatki do e-learningu": "",
        "Dodatkowe informacje": "",
        "Dodatkowe uwagi": "",
        "Dodawanie": "",
        "Dodawanie dokumentów": "",
        "Dodawanie i edycja własnych dokumentów": "",
        "Dodawanie odznaki": "",
        "Dodawanie punktów": "",
        "Dodawanie wartości dwóch kolumn": "",
        "Dokument": "",
        "Dokument %0": "",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "",
        "Dokument nie ma ustawionej daty publikacji.": "",
        "Dokument PDF": "",
        "Dokument tekstowy": "",
        "Dokument został dodany.": "",
        "Dokument został usunięty.": "",
        "Dokument został zaktualizowany.": "",
        "Dokument_": "",
        "Dokumenty": "",
        "Dołącz stack trace": "",
        "Dołącz stronę do pliku sitemap.xml": "",
        "Dołączanie plików": "",
        "Domena": "",
        "Domyślna": "",
        "Domyślna wartość": "",
        "Domyślna witryna": "",
        "Domyślne": "",
        "Domyślne filtry": "",
        "Domyślne ustawienie dla witryny": "",
        "Domyślnie ukryte": "",
        "Domyślnie widoczne": "",
        "Domyślny": "",
        "Domyślny poziom logowania": "",
        "Domyślny tytuł aktywnej strony": "",
        "Dopasowanie": "",
        "Dopasuj do kategorii": "",
        "Dopasuj do obrazka": "",
        "Dopuść brak odpowiedzi": "",
        "Dostawca": "",
        "Dostęp ": "",
        "Dostęp do": "",
        "Dostęp do modułu": "",
        "Dostęp do terminu": "",
        "dostęp indywidualny": "",
        "Dostęp niezdefiniowany": "",
        "Dostęp od": "",
        "Dostęp przyznany": "",
        "Dostęp przyznany przez zespół": "",
        "Dostęp przyznany ręcznie": "",
        "dostęp z zespołu": "",
        "Dostęp zabroniony": "",
        "Dostępna jest nowa aktualizacja. Proszę zapisać postęp pracy i klinąć przycisk \"Aktualizuj\". Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Dostępne": "",
        "Dostępne bloki": "",
        "Dostępne dla": "",
        "Dostępne języki": "",
        "Dostępne moduły": "",
        "Dostępne są tylko wydarzenia, które mają włączoną opcję \"Wydarzenie dostępne tylko w module spotkań\"": "",
        "Dostępne wersje językowe.": "",
        "Dostępny do": "",
        "Dostępny limit": "",
        "Dostępny od": "",
        "Dostępny w sekcjach": "",
        "Dostępy": "",
        "Dotyczy tylko ikon dodanych w odpowiednim formacie wektorowym SVG": "",
        "Double": "",
        "dowolnej wybranej wersji": "",
        "Dowolny": "",
        "Dozwolone rozszerzenia": "",
        "Dozwolone rozszerzenia plików": "",
        "Dozwolone rozszerzenia: %0.": "",
        "Dozwolone są tylko małe i duże litery": "",
        "Dozwolone są tylko małe litery i znak -": "",
        "Dozwolone typy plików: %0.": "",
        "Dół": "",
        "Drugi": "",
        "Drugi klucz (MD5)": "",
        "Drugie imię": "",
        "Dsn": "",
        "Duplikuj": "",
        "Duża": "",
        "Duże litery": "",
        "Duży": "",
        "Duży układ siatki": "",
        "Dwie kolumny": "",
        "Dyrektywa max-age=N wskazuje, że odpowiedź pozostaje świeża do N sekund po wygenerowaniu odpowiedzi.": "",
        "Dyrektywa no-store wskazuje, że jakikolwiek cache dowolnego rodzaju nie powinien przechowywać tej odpowiedzi.": "",
        "Dyrektywa PRIVATE wskazuje, że odpowiedź może być przechowywana wyłącznie w prywatnej pamięci podręcznej (np. lokalnej pamięci przeglądarki).": "",
        "Dyrektywa przechowywania": "",
        "Dyrektywa PUBLIC wskazuje, że odpowiedź może być przechowywana we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywa s-maxage jest ignorowana przez prywatne pamięci podręczne i zastępuje wartość określoną przez dyrektywę max-age dla współdzielonych pamięci podręcznych.": "",
        "Dyrektywa s-maxage wskazuje, jak długo odpowiedź pozostaje aktualna we współdzielonej pamięci podręcznej (np. proxy).": "",
        "Dyrektywy zakresu": "",
        "Dział aktywny": "",
        "Dział nadrzędny": "",
        "Dział został dodany.": "",
        "Dział został zaktualizowany.": "",
        "Działania masowe": "",
        "Działanie modułu w oparciu o": "",
        "Dzielenie": "",
        "Dzienny": "",
        "dzień": "",
        "Dzień": "",
        "dzień (dni)": "",
        "Dzień miesiąca": "",
        "Dzisiaj": "",
        "E-learning": "",
        "E-mail": "",
        "Edycja": "",
        "Edycja aktualności": "",
        "Edycja ankiety": "",
        "Edycja aranżacji": "",
        "Edycja aranżacji dashboardu": "",
        "Edycja artykułu": "",
        "Edycja asystenta": "",
        "Edycja autora": "",
        "Edycja certyfikatu": "",
        "Edycja czołówki": "",
        "Edycja dashboardu": "",
        "Edycja dokumentów": "",
        "Edycja dokumentu": "",
        "Edycja działu": "",
        "Edycja endpointu": "",
        "Edycja etykiety": "",
        "Edycja formularza": "",
        "Edycja funkcji": "",
        "Edycja galerii": "",
        "Edycja jest obecnie niedostępna, ponieważ trwa proces przetwarzania danych związanych z terminami szkoleń": "",
        "Edycja kategorii": "",
        "Edycja kategorii wydarzenia": "",
        "Edycja klienta": "",
        "Edycja kolekcji": "",
        "Edycja komentarza": "",
        "Edycja komponentu": "",
        "Edycja lekcji": "",
        "Edycja linku": "",
        "Edycja logów": "",
        "Edycja modułu": "",
        "Edycja odznaki": "",
        "Edycja opcji płatności": "",
        "Edycja paczek SCORM": "",
        "Edycja pliku": "",
        "Edycja poradnika": "",
        "Edycja produktu": "",
        "Edycja punktów": "",
        "Edycja regulaminu": "",
        "Edycja roli": "",
        "Edycja rotatora": "",
        "Edycja scenariusza": "",
        "Edycja serwera": "",
        "Edycja slajdera": "",
        "Edycja slajdów": "",
        "Edycja spotkania": "",
        "Edycja stanowiska": "",
        "Edycja strony": "",
        "Edycja szablonu": "",
        "Edycja szkolenia": "",
        "Edycja ścieżki szkoleniowej": "",
        "Edycja terminu": "",
        "Edycja testu": "",
        "Edycja top tematu": "",
        "Edycja ustawień": "",
        "Edycja użytkownika": "",
        "Edycja w popupie": "",
        "Edycja webhooka": "",
        "Edycja wideo": "",
        "Edycja witryny": "",
        "Edycja wszystkich dokumentów": "",
        "Edycja wydarzenia": "",
        "Edycja zamówienia": "",
        "Edycja zastępstwa": "",
        "Edycja zespołu": "",
        "Edycja zestawu regulaminów": "",
        "Edycja źródła": "",
        "Edycja źródła danych": "",
        "Edytor": "",
        "Edytor lokalizowany": "",
        "Edytowana wersja": "",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "",
        "Edytuj": "",
        "Edytuj blok": "",
        "Edytuj członka grupy": "",
        "Edytuj dashboard": "",
        "Edytuj datę dostępu": "",
        "Edytuj dokument": "",
        "Edytuj filtr": "",
        "Edytuj katalog": "",
        "Edytuj kategorie": "",
        "Edytuj kategorię": "",
        "Edytuj komentarz": "",
        "Edytuj lekcje": "",
        "Edytuj lekcje SCORM": "",
        "Edytuj lekcje wideo": "",
        "Edytuj link": "",
        "Edytuj powiadomienie zbiorowe": "",
        "Edytuj punkt": "",
        "Edytuj rotator": "",
        "Edytuj slajder": "",
        "Edytuj stronę": "",
        "Edytuj szablon": "",
        "Edytuj tag": "",
        "Edytuj temat": "",
        "Edytuj test": "",
        "Edytuj uprawnienia": "",
        "Edytuj użytkownika": "",
        "Edytuj wątek": "",
        "Edytuj wiersz": "",
        "Edytuj wpis": "",
        "Edytuj wydarzenie": "",
        "Edytuj zestaw": "",
        "Eksport": "",
        "Eksport do Excela": "",
        "Eksport dokumentów": "",
        "Eksport użytkowników": "",
        "Eksport zamówień": "",
        "ElasticSearch": "",
        "element": "",
        "Element": "",
        "Element grupujący": "",
        "Element jest wymagany": "",
        "Element nadrzędny": "",
        "element niewymagany": "",
        "Element opublikowany": "",
        "Element szkolenia rozpoczęty przez użytkowników": "",
        "Element szkolenia ukończony przez użytkowników": "",
        "element wymagany": "",
        "Element wymagany": "",
        "Element został dodany.": "",
        "Element został przywrócony.": "",
        "Element został usunięty": "",
        "Element został usunięty.": "",
        "Element został zaktualizowany.": "",
        "elementów": "",
        "elementy": "",
        "Elementy": "",
        "Elementy szkolenia": "",
        "Elementy szkolenia użytkownika": "",
        "Elementy szkolenia użytkownika: ${selectedUserData}": "",
        "Elementy zostały usunięte.": "",
        "Email": "",
        "Email potwierdzony": "",
        "Endpoint został dodany.": "",
        "Endpoint został zaktualizowany.": "",
        "Error - błedy wewnętrze SDK": "",
        "Eskportuj": "",
        "Etap": "",
        "Etykieta": "",
        "Etykieta produktu została dodana.": "",
        "Etykieta produktu została usunięta.": "",
        "Etykieta produktu została zaktualizowana.": "",
        "Etykieta została dodana.": "",
        "Etykieta została usunięta.": "",
        "Etykieta została zaktualizowana.": "",
        "Etykiety": "",
        "Etykiety produktów": "",
        "Export": "",
        "Exportuj do Excela": "",
        "Facebook": "",
        "Facebook Admins": "",
        "Facebook Application ID": "",
        "Faktura": "",
        "False": "",
        "Fatal - błedy krytyczne": "",
        "FavIcona": "",
        "Film": "",
        "Film z multimedia": "",
        "Film z YouTube": "",
        "Filmy": "",
        "Filtr dla synchronizacji działów": "",
        "Filtr dla synchronizacji użytkowników": "",
        "Filtr domyślny": "",
        "Filtr prywatny": "",
        "Filtr został usunięty": "",
        "Filtr został zapisany": "",
        "Filtrowanie": "",
        "Filtrowanie listy dokumentów": "",
        "Filtry": "",
        "Firebase": "",
        "Firebase config": "",
        "Folder główny": "",
        "Folder plików": "",
        "Folder został usunięty.": "",
        "Foldery": "",
        "Format pliku": "",
        "Format treści": "",
        "Formatowanie ramki": "",
        "Formularz": "",
        "Formularz bazuje na nieaktualnej wersji definicji.": "",
        "Formularz dynamiczny": "",
        "Formularz został dodany.": "",
        "Formularz został skopiowany.": "",
        "Formularz został utworzony.": "",
        "Formularz został zaakceptowany.": "",
        "Formularz został zaktualizowany.": "",
        "Formularze": "",
        "Formuła jest nieprawidłowa": "",
        "Funkcja została dodana.": "",
        "Funkcja została usunięta.": "",
        "Funkcja została zaktualizowana.": "",
        "Funkcje": "",
        "Funkcje Asystent": "",
        "Funkcje asystenta": "",
        "Funkcje Asystenta": "",
        "Funkcje asystenta AI": "",
        "Funkcjonalności": "",
        "Funkcjonalność AI": "",
        "Galeria": "",
        "Galeria nie jest jeszcze nigdzie opublikowana.": "",
        "Galeria nie ma ustawionej daty publikacji.": "",
        "Galeria zdjęć": "",
        "Galeria zdjęć premium": "",
        "Galeria została dodana.": "",
        "Galeria została usunięta.": "",
        "Galeria została zaktualizowana.": "",
        "Generator dynamicznych formularzy włączony": "",
        "Generator dynamicznych formularzy wyłączony": "",
        "Generator linku": "",
        "Generator metadanych obrazu włączony": "",
        "Generator metadanych obrazu wyłączony": "",
        "Generator metadanych SEO włączony": "",
        "Generator metadanych SEO wyłączony": "",
        "Generator obrazów AI": "",
        "Generator obrazów włączony": "",
        "Generator obrazów wyłączony": "",
        "Generowanie formularza zakończone.": "",
        "Generowanie obrazów": "",
        "Generowanie obrazów zakończone.": "",
        "Generowanie planu": "",
        "Generowanie planu szkolenia rozpoczęte": "",
        "Generowanie szkolenia": "",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut.": "",
        "Generowanie szkolenia zostało rozpoczęte, może to potrwać kilka minut. Wygenerowane szkolenie znajdziesz na liście szkoleń pod nazwą: ": "",
        "Generowanie zdjęcia głównego do szkolenia": "",
        "Generuj": "",
        "Generuj formularz": "",
        "Generuj metadane": "",
        "Generuj metadane (AI)": "",
        "Generuj nowy link": "",
        "Generuj nowy obraz": "",
        "Generuj obraz": "",
        "Generuj plan": "",
        "Generuj plan szkolenia": "",
        "Generuj szkolenie": "",
        "Generuj treść slajdu": "",
        "Generuj wszystkie metadane": "",
        "GET: Lista wpisów (sortowanie i stronicowanie)": "",
        "GET: Pobranie danych": "",
        "GET: Pobranie wpisu": "",
        "GET: Schemat (definicja formularza)": "",
        "Główny asystent panelu": "",
        "Godziny": "",
        "Google": "",
        "Google Nexus 10": "",
        "Google Nexus 5": "",
        "Google Nexus 7": "",
        "Google Translate V2": "",
        "Góra": "",
        "GPT-4 Turbo": "",
        "GPT-4 Vision": "",
        "GPT-4o": "",
        "GPT-4o mini": "",
        "GPT-4o Mini": "",
        "Grafika": "",
        "Grafika na stronie logowania": "",
        "Grafika wektorowa": "",
        "Grubość": "",
        "Grubość ramki": "",
        "grudniu": "",
        "grudzień": "",
        "Grudzień": "",
        "Grupa": "",
        "Grywalizacja": "",
        "Harmonogram": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasło": "",
        "Hasło (Klucz ukryty)": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny np.: ~ @ # $ % ^ & *": "",
        "Hasło użytkownika serwisowego": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "Health": "",
        "Hierarchia": "",
        "Hierarchiczny": "",
        "Historia": "",
        "Historia logowania": "",
        "Historia wygenerowanych treści.": "",
        "Historia zadania": "",
        "Historia zapytań AI": "",
        "Historia zapytań do AI": "",
        "Host": "",
        "Host dodatkowy": "",
        "Host główny": "",
        "i": "",
        "i posiadających wymagane uprawnienia": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu: %0": "",
        "Id obiektu": "",
        "ID operacji": "",
        "ID procesu": "",
        "Id punktu płatności (pos_id)": "",
        "Id sesji": "",
        "Id slajdu": "",
        "Id wpisu": "",
        "ID zadania": "",
        "Id zapytania": "",
        "Id zdarzenia": "",
        "Identity": "",
        "Identyfikator": "",
        "Identyfikator odpowiedzi.": "",
        "Identyfikator przestrzeni (WorkspaceId)": "",
        "Identyfikator sklepu (domyślnie id sprzedawcy)": "",
        "Identyfikator slajdu": "",
        "Identyfikator sprzedawcy": "",
        "Identyfikator wdrożenia": "",
        "Identyfikator zadania": "",
        "Identyfikator zapytania": "",
        "Ikona": "",
        "Ikona wyświetlana jest w postaci kwadratu.": "",
        "Ilość elementów: %0": "",
        "Ilość powtórzeń po wystąpieniu błędu": "",
        "Ilość wierszy": "",
        "Ilość wyników do odrzucenia": "",
        "Ilość wyników do pobrania": "",
        "Ilość znaków": "",
        "Ilość znaków odpowiedzi": "",
        "Imię": "",
        "Imię i nazwisko": "",
        "Imię i Nazwisko": "",
        "Imię i nazwisko/nazwa autora": "",
        "Import": "",
        "Import modułu": "",
        "Import slajdów z PDF": "",
        "Import użytkowników": "",
        "Importuj": "",
        "Importuj definicję formularza": "",
        "Importuj slajdy": "",
        "Indeks": "",
        "Indeks został usunięty.": "",
        "Indeksowanie strony": "",
        "Indywidualny": "",
        "Indywidualny z terminu spotkań": "",
        "Info - informacje": "",
        "Informacja": "",
        "Informacja o błędzie": "",
        "Informacja o ciasteczkach": "",
        "Informacje dodatkowe": "",
        "Inspekcja": "",
        "Instalacja": "",
        "Instrukcja": "",
        "Instrukcja modelu (prompt).": "",
        "Instrukcja warunkowa": "",
        "Int": "",
        "Inteligentne narzędzie generujące dynamiczne formularze.": "",
        "Inteligentne narzędzie generujące metadane obrazu.": "",
        "Inteligentne narzędzie generujące metadane SEO.": "",
        "Inteligentne narzędzie generujące obrazy.": "",
        "Inteligentne narzędzie wskazujące najbardziej trafny wynik wyszukiwania.": "",
        "Interakcja użytkownika": "",
        "Interpreter kodu": "",
        "Interpreter kodu umożliwia asystentowi pisanie i uruchamianie kodu. To narzędzie może przetwarzać pliki z różnymi danymi i formatowaniem oraz generować pliki.": "",
        "ISBN": "",
        "Jakość": "",
        "Jakość HD": "",
        "Jakość HD 1024x1024": "",
        "Jakość HD 1024x1792 i 1792x1024": "",
        "Jakość standardowa": "",
        "Jakość standardowa 1024x1024": "",
        "Jakość standardowa 1024x1792 i 1792x1024": "",
        "Jakość wygnerowanego obrazu.": "",
        "Jasny": "",
        "Jasny niebieski": "",
        "Jedna kolumna": "",
        "Jednokrotnego wyboru": "",
        "Jeszcze nie ma kategorii.": "",
        "Jeśli danego użytkownika nie ma na liście, oznacza to, że brakuje podstawowych danych takich jak Imię i Nazwisko. Uzupełnij te dane w dziale Użytkownicy.": "",
        "Jeśli pole jest puste to wstawiana automatycznie.": "",
        "Jeśli pole jest puste, wówczas używana jest wartość domyślna. W przeciwnym wypadku wartość domyślna jest nadpisywana.": "",
        "Język": "",
        "Język domyślny": "",
        "Kalendarz": "",
        "Kalendarz - Kategorie zasobów": "",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "",
        "kanał wymagany": "",
        "Kanały": "",
        "Kanały komunikacji": "",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "",
        "Kanały włączone w ustawieniach aplikacji": "",
        "Katalog": "",
        "Katalog linków": "",
        "Katalog został utworzony": "",
        "Katalog został utworzony.": "",
        "Kategoria": "",
        "Kategoria jest wymagana": "",
        "Kategoria linku": "",
        "Kategoria materiałów": "",
        "Kategoria materiału": "",
        "Kategoria nadrzędna": "",
        "Kategoria produktu": "",
        "Kategoria slajdu": "",
        "Kategoria spotkania": "",
        "Kategoria subskrypcji": "",
        "Kategoria subskrypcji została dodana.": "",
        "Kategoria subskrypcji została usunięta.": "",
        "Kategoria subskrypcji została zaktualizowana.": "",
        "Kategoria szkolenia": "",
        "Kategoria wydarzenia": "",
        "Kategoria wyszukiwanego materiału": "",
        "Kategoria została dodana.": "",
        "Kategoria została usunięta.": "",
        "Kategoria została zaktualizowana.": "",
        "Kategoria: ": "",
        "Kategorie": "",
        "Kategorie linków": "",
        "Kategorie materiałów": "",
        "Kategorie produktów": "",
        "Kategorie spotkań": "",
        "Kategorie szkoleń": "",
        "Kategorie wydarzeń": "",
        "Kategorię": "",
        "Kategorię można opublikować tylko na jednej stronie.": "",
        "Kategorię subskrypcji": "",
        "Key": "",
        "Key pair": "",
        "Klienci": "",
        "Klient aktywny": "",
        "Klient został dodany.": "",
        "Klient został usunięty.": "",
        "Klient został zaktualizowany.": "",
        "Klucz": "",
        "Klucz API": "",
        "Klucz główny (PrimaryKey)": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucze": "",
        "Klucze są nie prawidłowe.": "",
        "Klucze są prawidłowe.": "",
        "Kobieta": "",
        "Kod bannera (tutaj wklej kod HTML i JS)": "",
        "Kod Bing Webmaster": "",
        "Kod Google Webmaster": "",
        "Kod GTM": "",
        "Kod HTML": "",
        "Kod pocztowy": "",
        "Kod walidacji": "",
        "Kod wertfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kod źródłowy": "",
        "Kolejka": "",
        "Kolejne pozycje z lewej strony": "",
        "Kolejne pozycje z prawej strony": "",
        "Kolejność zaliczania elementów": "",
        "Kolekcja aktywna": "",
        "Kolekcja promowana": "",
        "Kolekcja została dodana.": "",
        "Kolekcja została zaktualizowana.": "",
        "Kolekcje produktów": "",
        "Kolor": "",
        "Kolor cyfr": "",
        "Kolor drugorzędny: %0": "",
        "Kolor icon na panelu z aplikacjami: %0": "",
        "Kolor ikony": "",
        "Kolor podpisów": "",
        "Kolor podstawowy: %0": "",
        "Kolor przewodni obrazu": "",
        "Kolor ramki": "",
        "Kolor tekstu": "",
        "Kolor tekstu aktywnej pozycji menu: %0": "",
        "Kolor tła": "",
        "Kolor tła panelu z aplikacjami: %0": "",
        "Kolory zostały przywrócone.": "",
        "Kolory zostały zapisane.": "",
        "Kolumna": "",
        "Kolumny": "",
        "Komentarz %0": "",
        "Komentarze": "",
        "Komponent którego wartość zostanie użyta jako nazwa elementu nadrzędnego. Dostępne tylko komponenty typu 'Tekst'.": "",
        "Komponent relacyjny": "",
        "Komponent został dodany.": "",
        "Komponent został usunięty.": "",
        "Komponent został zaktualizowany.": "",
        "Komponent źródłowy": "",
        "Komponenty": "",
        "Komunikat": "",
        "Komunikat błędu": "",
        "Komunikat mailowy": "",
        "Komunikat po niezaliczeniu testu": "",
        "Komunikat po otrzymaniu odznaki": "",
        "Komunikat po zaliczeniu testu": "",
        "Komunikat walidacji": "",
        "Konfiguracja": "",
        "Konfiguracja AI": "",
        "Konfiguracja aranżacji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja asystenta": "",
        "Konfiguracja asystenta ai": "",
        "Konfiguracja bloków jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja bloku": "",
        "Konfiguracja bloku została zapisana.": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja kolumn tabeli": "",
        "Konfiguracja listy": "",
        "Konfiguracja logów": "",
        "Konfiguracja sekcji jest niedostępna ponieważ nie podano definicji szablonu.": "",
        "Konfiguracja stopki oraz logo umieszczanych w wysyłanych powiadomieniach kanałem mailowym. Stopka może być skonfigurowana indywidualnie dla każdej wersji jezykowej, logo jest wspólne dla wszystkich.": "",
        "Konfiguracja zaawansowana": "",
        "Konfiguracja zapytania": "",
        "Konfiguracja została przywrócona dla reguł i celów": "",
        "Konfiguracja została zmieniona.": "",
        "Konfiguruj stronę": "",
        "Koniec po": "",
        "Konsola aplikacji": "",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "",
        "Konta użytkowników": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały przypisane do zespołu": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakt": "",
        "Kontakty - Typ działania": "",
        "Kontener plików": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne dopóki adres e-mail nie zostanie potwierdzony": "",
        "Konto publiczne": "",
        "Konto z dostępem do panelu administracyjnego": "",
        "Konto zanonimizowane": "",
        "Kontrolka": "",
        "Kontrolka wyboru (pojedynczy wybór, value jest skrótem pobierającym pierwszy element z tablicy data)": "",
        "Kontrolka wyboru (wybór wielokrotny)": "",
        "Konwertuj obrazy do formatu WebP": "",
        "Końcowa": "",
        "Koordynator": "",
        "Koordynatorów": "",
        "Koordynowane szkolenia:": "",
        "Kopiuj": "",
        "Kopiuj adres": "",
        "Kopiuj definicję": "",
        "Kopiuj pole": "",
        "Kosz": "",
        "Kraj": "",
        "Kreator może też zaproponować własną strukturę szkolenia.": "",
        "Kreator najlepiej interpretuje pliki w formacie": "",
        "Kreator szkoleń": "",
        "Kreator Szkoleń AI": "",
        "Krok 1": "",
        "Krok 2": "",
        "Krok 3": "",
        "Krok minut": "",
        "Krok minut musi być liczbą z zakresu od 1 do 60.": "",
        "Kroki": "",
        "Kropkowana": "",
        "Krótki opis": "",
        "Krótki tekst": "",
        "Krótki tytuł": "",
        "Książka": "",
        "kwiecień": "",
        "Kwiecień": "",
        "kwietniu": "",
        "Laptop 15,6\"": "",
        "Laptop 15\"": "",
        "Laptop 17\"": "",
        "Ldap": "",
        "LDAPS (LDAP over SSL)": "",
        "Legenda": "",
        "Lekcja": "",
        "Lekcja do powtórzenia": "",
        "Lekcja może zawierać tylko materiały opisowe": "",
        "Lekcja może zawierać tylko materiały opisowe lub materiały video": "",
        "Lekcja SCORM ukryta": "",
        "Lekcja SCORM została dodana.": "",
        "Lekcja SCORM została zaktualizowana.": "",
        "Lekcja ukryta": "",
        "Lekcja wideo została dodana.": "",
        "Lekcja wideo została zaktualizowana.": "",
        "Lekcja została dodana.": "",
        "Lekcja została zaktualizowana.": "",
        "Lekcje": "",
        "Lekcje video": "",
        "Lewo": "",
        "Lewy panel": "",
        "Licencja": "",
        "Liczba": "",
        "Liczba artykułów": "",
        "Liczba artykułów w kategorii": "",
        "Liczba całkowita": "",
        "Liczba danych wejściowych podana w tokenach.": "",
        "Liczba danych wyjściowych podana w tokenach.": "",
        "Liczba dni co ile wysyłane jest powiadomienie": "",
        "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "",
        "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "",
        "Liczba dostępnych bloków": "",
        "Liczba dziesiętna": "",
        "Liczba elementów": "",
        "Liczba elementów do uzupełnienia": "",
        "Liczba kategorii": "",
        "Liczba koordynatorów": "",
        "Liczba koordynowanych szkoleń: %0": "",
        "Liczba miejsc": "",
        "Liczba odpowiedzi": "",
        "Liczba opublikowanych elementów (zakładka Zawartość) musi być większa lub równa ustawionej liczbie wyświetlanych elementów (zakładka Ustawienia)": "",
        "Liczba podejść": "",
        "Liczba podejść nie może być mniejsza niż 0": "",
        "Liczba powtórzeń": "",
        "Liczba produktów": "",
        "Liczba punktów": "",
        "Liczba punktów nie może być liczbą ujemną": "",
        "Liczba pytań": "",
        "Liczba pytań w teście": "",
        "Liczba slajdów w lekcji": "",
        "Liczba slajdów widoczna dla użytkownika nie może być większa od liczby slajdów dodanych w panelu.": "",
        "Liczba spotkań": "",
        "Liczba szkoleń": "",
        "Liczba szkoleń w ścieżce": "",
        "Liczba uczestników": "",
        "Liczba użytkowników": "",
        "Liczba użytkowników szkolenia": "",
        "Liczba wariantów": "",
        "Liczba wydarzeń": "",
        "Liczba wyników na stronie": "",
        "Liczba wyświetlanych aktualności": "",
        "Liczba wyświetlanych artykułów": "",
        "Liczba wyświetlanych elementów": "",
        "Liczba wyświetlanych najnowszych elementów": "",
        "Liczba wyświetlanych produktów": "",
        "Liczba wyświetlanych slajdów": "",
        "Liczba wyświetlanych tagów": "",
        "Liczba wyświetleń": "",
        "Liczba zaimportowanych użytkowników: ${importInformations.importedAccounts}": "",
        "Liczba zakładek": "",
        "Liczba zapisanych": "",
        "Liczba zapisanych osób": "",
        "Liczba zapisanych/Liczba dostępnych miejsc: ": "",
        "Liczba zgłoszeń:": "",
        "Lider": "",
        "Lider/koordynator dla wszystkich zespołów": "",
        "Like do komentarzy mogą dodawać tylko zalogowani użytkownicy": "",
        "Limit": "",
        "Limit API": "",
        "Limit czasu (minuty)": "",
        "Limit czasu nie może być mniejszy niż 0 minut": "",
        "Limit dodanych linków": "",
        "Limit jest potrzebny do poprawnego wyświetlenia statystyk zużycia na stronie głównej panelu. Nie jest powiązany z limitem konta.": "",
        "Limit miejsc": "",
        "Limit zgłoszeń": "",
        "Limit znaków dla niezalogowanych": "",
        "Limit znaków dla zalogowanych": "",
        "Limity": "",
        "Linia": "",
        "Linia ciągła": "",
        "Linia falująca": "",
        "Linia kreskowana": "",
        "Linia kropkowana": "",
        "Linia pozioma": "",
        "linie": "",
        "Link": "",
        "Link (link zewnętrzny, bez https)": "",
        "Link do strony": "",
        "Link do wybranej strony serwisu": "",
        "Link do zewnętrznej strony": "",
        "Link przycisku": "",
        "Link z serwisu": "",
        "Link został dodany.": "",
        "Link został skopiowany.": "",
        "Link został usunięty.": "",
        "Link został wygenerowany.": "",
        "Link został zaktualizowany.": "",
        "lipcu": "",
        "lipiec": "",
        "Lipiec": "",
        "Lista": "",
        "Lista artykułów": "",
        "Lista asystentów": "",
        "Lista certyfikatów": "",
        "Lista dostępnych zmiennych, które można wykorzystać we wszystkich polach tekstowych:": "",
        "Lista dozwolonych / wykluczonych żądań HTTP": "",
        "Lista efektywnych uprawnień użytkownika wynikających z uprawnień indywidualnych oraz ról.": "",
        "Lista elementów": "",
        "Lista elementów zostanie zawężona tylko do tych, które są pozwiązane z wybranymi wartościami z zaznaczonych komponentów.": "",
        "Lista ID": "",
        "Lista indeksów": "",
        "Lista jest pusta": "",
        "Lista komentarzy": "",
        "Lista koordynatorów": "",
        "Lista linków": "",
        "Lista materiałów do utworzenia szkolenia": "",
        "Lista możliwości zakończenia czatu. W obecnym stanie model zwraca jedną możliwą odpowiedź.": "",
        "Lista paczek SCORM": "",
        "Lista plików": "",
        "Lista powiadomień zbiorowych": "",
        "Lista produktów": "",
        "Lista regulaminów": "",
        "Lista rezerwowa": "",
        "Lista rozszerzeń oddzielona przecinkami.": "",
        "Lista rozwijana": "",
        "Lista sortowalna": "",
        "Lista spotkań": "",
        "Lista szablonów": "",
        "Lista szkoleń": "",
        "Lista ścieżek szkoleniowych": "",
        "Lista uczestników": "",
        "Lista wiadomości (prompt) składających się na dotychczasową konwersację z modelem.": "",
        "Lista wyboru": "",
        "Lista wydarzeń": "",
        "Lista zamówień": "",
        "Lista zapisanych": "",
        "Lista zaufanych adresów IP": "",
        "Lista zespołów": "",
        "listopad": "",
        "Listopad": "",
        "listopadzie": "",
        "Listy": "",
        "Litery": "",
        "Litery i cyfry": "",
        "Log błędu": "",
        "Log z aktywności": "",
        "Logi": "",
        "Logi aktywności zostały wyczyszczone": "",
        "Logi wydajnościowe": "",
        "Login": "",
        "Logo": "",
        "Logowanie": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zależności / żądań typu HTTP": "",
        "Loguj wybrane": "",
        "Lokalizacja": "",
        "Lokalizowane": "",
        "Lokalne": "",
        "Long": "",
        "Lorem ipsum dolor sit amet, consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit.": "",
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quam commodi autem id, veniam, illum temporibus.": "",
        "Losowa kolejność elementów": "",
        "lub dokumenty z wyraźnie opisaną strukturą nagłówków i treści.": "",
        "luty": "",
        "Luty": "",
        "lutym": "",
        "Ładowanie elementów...": "",
        "Łączenie treści": "",
        "maj": "",
        "Maj": "",
        "maju": "",
        "Maksimum": "",
        "Maksymalna ilość plików": "",
        "Maksymalna liczba podejść to 500": "",
        "Maksymalna liczba punktów": "",
        "Maksymalna liczba tokenów": "",
        "Maksymalna limit czasu to 500 minut": "",
        "Maksymalna rozdzielość %0x%1px": "",
        "Maksymalny rozmiar pliku w MB": "",
        "Maksymalny rozmiar pliku: %0MB.": "",
        "Maksymalny rozmiar pojedynczego pliku": "",
        "Mała": "",
        "Małe litery": "",
        "Małe znaki": "",
        "Mały": "",
        "Mały układ siatki": "",
        "Mapa": "",
        "Mappingi": "",
        "marcu": "",
        "Margines [px": "",
        "Markdown": "",
        "Marketing": "",
        "marzec": "",
        "Marzec": "",
        "Masz niezapisane zmiany w materiałach. Zapisz je lub usuń aby móc zapisać element szkolenia.": "",
        "Materiał opisowy": "",
        "Materiał wideo": "",
        "Materiały szkoleniowe": "",
        "Max tokens": "",
        "Max: 250 znaków": "",
        "Mediana": "",
        "Messages": "",
        "Metadane": "",
        "Metoda": "",
        "Metoda autentykacji": "",
        "Metoda musi zwracać obiekt \"entry.errors\".": "",
        "Mężczyzna": "",
        "Miejsca po przecinku": "",
        "Miejscowość": "",
        "mies.": "",
        "miesiąc": "",
        "Miesiąc": "",
        "Miesiące": "",
        "Miesięcznie": "",
        "Miesięczny": "",
        "Migracje": "",
        "Miniaturka": "",
        "Miniaturka wideo": "",
        "Miniaturki": "",
        "Minimalna długość hasła": "",
        "Minimalna ilość plików": "",
        "Minimalny czas oglądania potrzebny do zaliczenia elementu (hh:mm:ss)": "",
        "Minimapa": "",
        "Minimum": "",
        "Minuty": "",
        "Mnożenie": "",
        "Model": "",
        "Model danych": "",
        "Model danych i cechy można skonfigurować tylko podczas dodawania nowego formularza.": "",
        "Model generuje odpowiedź na podstawie podanych przez użytkownika parametrów.": "",
        "Moderacja danych wejściowych": "",
        "Moderacja włączona": "",
        "Moderacja wyłączona": "",
        "Moderacjia danych wejściowych jest zalecana.": "",
        "Moduł": "",
        "Moduł dynamiczny": "",
        "Moduł konfigurowalny": "",
        "Moduł płatności": "",
        "Moduł spotkań": "",
        "Moduł został dodany.": "",
        "Moduł został usunięty.": "",
        "Moduł został wyeksportowany.": "",
        "Moduł został zaktualizowany.": "",
        "Moduły": "",
        "Moduły wyszukiwarki": "",
        "Modyfikacja": "",
        "Modyfikacja dokumentów": "",
        "Modyfikuj istniejący wątek": "",
        "Moje dokumenty": "",
        "Moje filtry": "",
        "Moje konto": "",
        "Moje pliki": "",
        "Moje punkty": "",
        "Moje wydarzenia": "",
        "Monitor aktywności": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Możesz podać nową nazwę pliku.": "",
        "Możesz wybrać maksymalnie ${props.maxFiles} pliki": "",
        "Możliwość dodawania linków przez użytkownika": "",
        "Możliwość modyfikacji tego działu jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość wielokrotnego wyboru": "",
        "Multimedia": "",
        "Multimedia premium": "",
        "multipart/form-data": "",
        "Na pewno usunąć": "",
        "Na pewno usunąć wybrane elementy?": "",
        "Na podstawie dołączonych plików oraz zaproponowanego planu zostanie utworzone szkolenie.": "",
        "Na podstawie dołączonych plików zostanie zaproponowany plan szkolenia.": "",
        "Na podstawie informacji zawartych w wybranych plikach zostanie utworzone szkolenie.": "",
        "Naciśnij enter aby usunąć": "",
        "Naciśnij enter aby wybrać": "",
        "Nadawanie uprawnień do dokumentów": "",
        "Nadawanie uprawnień do własnych dokumentów": "",
        "Nadawanie uprawnień do wszystkich dokumentów": "",
        "Nadawca": "",
        "Nadpisz wersję lekcji": "",
        "Nadpisz wersję lekcji scorm": "",
        "Nadpisz wersję lekcji wideo": "",
        "Nadpisz wersję linku": "",
        "Nadpisz wersję testu": "",
        "Nagłówek": "",
        "Nagłówek dokumentu": "",
        "Nagłówki cache": "",
        "Najniższy": "",
        "Najnowsze": "",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Najstarsza wiadomość": "",
        "Najwyższy": "",
        "Name": "",
        "Narzędzia": "",
        "Narzędzia AI": "",
        "Narzędzie integruje się z platformą Firebase (powiadomienia push)": "",
        "Narzędzie integruje się z platformą SMSAPI.pl": "",
        "Następna strona": "",
        "Następny": "",
        "Następny krok": "",
        "Nazwa": "",
        "Nazwa akcji": "",
        "Nazwa aktywnej strony": "",
        "Nazwa aliasu": "",
        "Nazwa aranżacji": "",
        "Nazwa asystenta": "",
        "Nazwa bazy danych": "",
        "Nazwa bloku": "",
        "Nazwa certyfikatu": "",
        "Nazwa czołówki": "",
        "Nazwa dashboardu": "",
        "Nazwa działu": "",
        "Nazwa elementu": "",
        "Nazwa etapu": "",
        "Nazwa etykiety": "",
        "Nazwa filtra": "",
        "Nazwa formularza": "",
        "Nazwa funkcji": "",
        "Nazwa grupy": "",
        "Nazwa indeksu": "",
        "Nazwa jest wymagana": "",
        "Nazwa katalogu": "",
        "Nazwa katalogu została zmieniona.": "",
        "Nazwa kategorii": "",
        "Nazwa Kategorii": "",
        "Nazwa klienta": "",
        "Nazwa kolekcji": "",
        "Nazwa kolumny": "",
        "Nazwa kolumny z opisem": "",
        "Nazwa kolumny z wartością": "",
        "Nazwa komponentu": "",
        "Nazwa konta (Klucz dostępu)": "",
        "Nazwa koordynatora": "",
        "Nazwa lekcji": "",
        "Nazwa linku": "",
        "Nazwa modelu": "",
        "Nazwa modułu": "",
        "Nazwa musi mieć co najmniej 3 znaki": "",
        "Nazwa musi mieć co najmniej 5 znaków": "",
        "Nazwa nadawcy": "",
        "Nazwa narzędzia": "",
        "Nazwa nie może być dłuższa niż 30 znaków": "",
        "Nazwa nie może być dłuższy niż 50 znaków": "",
        "Nazwa odznaki": "",
        "Nazwa odznaki dla użytkownika": "",
        "Nazwa operacji": "",
        "Nazwa paczki": "",
        "Nazwa paczki SCORM": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa płyty": "",
        "Nazwa pokoju": "",
        "Nazwa pola": "",
        "Nazwa powiadomienia": "",
        "Nazwa produktu": "",
        "Nazwa przycisku": "",
        "Nazwa przycisku 'Dalej'": "",
        "Nazwa przycisku 'Wstecz'": "",
        "Nazwa przycisku 'Wyślij'": "",
        "Nazwa roli": "",
        "Nazwa rotatora": "",
        "Nazwa scenariusza": "",
        "Nazwa sekcji": "",
        "Nazwa sekcji w menu": "",
        "Nazwa sekcji...": "",
        "Nazwa serwera": "",
        "Nazwa slajdera": "",
        "Nazwa slajdu": "",
        "Nazwa sposobu płatności": "",
        "Nazwa spotkania": "",
        "Nazwa spotkania: ": "",
        "Nazwa stanowiska": "",
        "Nazwa strony": "",
        "Nazwa szablonu": "",
        "Nazwa szkolenia": "",
        "Nazwa ścieżki": "",
        "Nazwa terminu": "",
        "Nazwa testu": "",
        "Nazwa typu": "",
        "Nazwa tytułu nie może być dłuższa niż 240 znaków ani krótsza niż 3 znaki.": "",
        "Nazwa urządzenia": "",
        "Nazwa użytkownika": "",
        "Nazwa użytkownika serwisowego": "",
        "Nazwa w panelu": "",
        "Nazwa wątku": "",
        "Nazwa webhooka": "",
        "Nazwa witryny": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana:": "",
        "Nazwa zadania": "",
        "Nazwa zasobu": "",
        "Nazwa zespołu": "",
        "Nazwa zestawu": "",
        "Nazwa zmiennej": "",
        "Nazwa zmiennej jest wymagana": "",
        "Nazwa zmiennej musi być unikalna": "",
        "nazwa zmiennej...": "",
        "Nazwa źródła": "",
        "Nazwa źródła danych": "",
        "Nazwa:": "",
        "Nazwisko": "",
        "Nazwy wartości": "",
        "nie": "",
        "Nie": "",
        "Nie loguj wybranych": "",
        "Nie ma jeszcze żadnych kategorii.": "",
        "Nie masz dostępu do tego modułu": "",
        "Nie masz uprawnień do modyfikacji aranżacji.": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do publikacji aranżacji.": "",
        "Nie masz uprawnień do tego dokumentu": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz dodać tego samego widgetu dwa razy": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie można tworzyć zapętlonych powiązań.": "",
        "Nie można ustawić dat dostępów dla szkoleń cyklicznych.": "",
        "Nie można usunąć kategorii do ktorej są przypisane elementy.": "",
        "Nie można usunąć swojego konta.": "",
        "Nie można zapisać zmian ponieważ skrypt się nie kompiluje.": "",
        "Nie podano": "",
        "Nie podano nazwy poprzedniego elementu.": "",
        "Nie podano nazwy poprzedniej kategorii.": "",
        "Nie podano nazwy tytułu.": "",
        "Nie podano odpowiedzi dla ostatniego elementu.": "",
        "Nie podano opisu.": "",
        "Nie podano wymaganej ilości znaków: %0.": "",
        "Nie podano wymaganej ilości znaków: %0. (%1)": "",
        "Nie pokazuj krótkiego opisu strony w wynikach wyszukiwania (NoSnippet)": "",
        "Nie pokazuj linku do archiwum strony (NoArchive)": "",
        "Nie pokazuj strony jako źródła grafiki w wynikach wyszukiwania (NoImageIndex)": "",
        "Nie udało się pobrać kategorii": "",
        "Nie udało się pobrać konfiguracji dashboardu": "",
        "Nie udało się pobrać listy aranżacji": "",
        "Nie udało się pobrać listy bloków": "",
        "Nie udało się pobrać listy celów": "",
        "Nie udało się pobrać listy działów": "",
        "Nie udało się pobrać listy etykiet": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kanałów": "",
        "Nie udało się pobrać listy kategorii": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy modułów": "",
        "Nie udało się pobrać listy modułów wyszukiwarki": "",
        "Nie udało się pobrać listy powiadomień": "",
        "Nie udało się pobrać listy regulaminów": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy serwerów baz danych": "",
        "Nie udało się pobrać listy serwerów plików": "",
        "Nie udało się pobrać listy stanowisk": "",
        "Nie udało się pobrać listy stron": "",
        "Nie udało się pobrać listy szablonów": "",
        "Nie udało się pobrać listy typów materiałów": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać listy wydziałów": "",
        "Nie udało się pobrać listy zespołów": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się pobrać ustawień kont użytkowników": "",
        "Nie udało się pobrać widgetu/ów": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się wczytać podglądu strony.": "",
        "Nie udało się wygenerować formularza": "",
        "Nie udało się wykonać akcji": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się zakutalizować plików asystenta": "",
        "Nie udało się załadować elementów": "",
        "Nie udało się załadować widgetu AI.": "",
        "Nie udało się zapisać filtra": "",
        "Nie udało się zapisać ustawień dashboardu": "",
        "Nie wszystkie pola zostały wypelnione prawidłowo.": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wybrano ankiety": "",
        "Nie wybrano authora.": "",
        "Nie wybrano obrazu.": "",
        "Nie wybrano paczki.": "",
        "Nie wybrano plików": "",
        "Nie wybrano strony": "",
        "Nie wybrano użytkownika.": "",
        "Nie wybrano żadnego użytkownika.": "",
        "Nie wybrano żadnej kategorii": "",
        "Nie wybrano żadnej kategorii.": "",
        "Nie wybrano żadnej strony.": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie wypełniono poprzedniego wiersza.": "",
        "Nie zdefiniowano żadnych ról.": "",
        "Nie zdefiniowano żadnych sekcji.": "",
        "Nie znaleziono dostępnych widgetów": "",
        "Nie znaleziono elementu.": "",
        "Nie znaleziono filtrów.": "",
        "Nie znaleziono formularza.": "",
        "Nie znaleziono kolumn.": "",
        "Nie znaleziono pasującego widgetu": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono żadnego pola.": "",
        "Nie znaleziono żadnych elementów": "",
        "Nie znaleziono żadnych folderów.": "",
        "Nie znaleziono żadnych linków.": "",
        "Nie znaleziono żadnych plików": "",
        "Nie znaleziono żadnych użytkowników.": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nieaktywne": "",
        "Nieaktywni": "",
        "Nieaktywny": "",
        "Niebieski": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "Niedozwolone słowa": "",
        "niedozwolony typ pliku (%0)": "",
        "Niedziela": "",
        "Nieobecny": "",
        "Nieopłacone": "",
        "Nieopublikowane": "",
        "Niepoprawne wyrażenie regularne": "",
        "Niepoprawny format wygenrowanego planu szkolenia": "",
        "Niepotwierdzeni": "",
        "Nieprawidłowa definicja": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Niepromowany": "",
        "Nieprzeczytane": "",
        "Niepubliczne": "",
        "Nierozpoczęli": "",
        "Nierozpoczęty": "",
        "Niestandardowy adres": "",
        "Niestandardowy adres strony": "",
        "Niestandardowy błąd": "",
        "Niestandardowy nagłówek": "",
        "Nieudane logowania": "",
        "Niewidoczne": "",
        "Niezaliczenie testu jest równoznaczne z potwierdzeniem obecności użytkownika": "",
        "Niezaliczone": "",
        "Niezaliczony": "",
        "Niezaliczyło": "",
        "Nieznane narzędzie": "",
        "Nieznany model": "",
        "Nieznany typ pliku": "",
        "Niezrealizowane": "",
        "Nigdy": "",
        "Nikomu nie przydzielono uprawnień": "",
        "Niski": "",
        "Niżej": "",
        "no-store (wyłącza cache)": "",
        "Nowa data": "",
        "Nowe hasło": "",
        "Nowe połączenie": "",
        "Nowy materiał": "",
        "np. (&(objectClass=organizationalUnit))": "",
        "np. (&(objectClass=user)": "",
        "np. pl-PL": "",
        "Number": "",
        "Numer": "",
        "Numer aktywnej strony": "",
        "Numer budynku": "",
        "Numer domu": "",
        "Numer konta": "",
        "Numer mieszkania": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "Numer zamówienia": "",
        "Numerowanie zamówień": "",
        "O szkoleniu": "",
        "OAuth2 dla Exchange Online": "",
        "Obecność": "",
        "Obecność została potwierdzona.": "",
        "Obecny": "",
        "Obiekt %0 został %1": "",
        "Object": "",
        "Obok siebie": "",
        "Obraz": "",
        "Obraz został pomyślnie opisany": "",
        "Obraz został wycięty.": "",
        "Obrazek": "",
        "Obrazek wyróżniający": "",
        "Obsługa progu przez platformę": "",
        "Obsługiwane formaty plików: txt, md, pdf, docx.": "",
        "Ocena offline": "",
        "Oczekujące": "",
        "Oczekujący na akceptację moderatora": "",
        "Oczekuje na akceptację": "",
        "Oczekuje na wysłanie": "",
        "Oczekuje na zatwierdzenie": "",
        "od": "",
        "Od": "",
        "od %0": "",
        "Od poziomu": "",
        "Odbiorca": "",
        "Odblokuj": "",
        "Odejmowanie": "",
        "Odliczanie daty": "",
        "Odnośnik URL": "",
        "Odpowiedzi": "",
        "Odpowiedzi: %0 na %1": "",
        "Odpowiedź": "",
        "Odpowiedź dowolna": "",
        "Odrzucone": "",
        "Odrzucone zgody": "",
        "Odrzucony po zgłoszeniach": "",
        "Odrzuć": "",
        "Odstęp": "",
        "Odśwież": "",
        "Odznacz": "",
        "Odznacz wszystkie": "",
        "Odznaka została dodana.": "",
        "Odznaka została zaktualizowana.": "",
        "Odznaki": "",
        "Ogólne": "",
        "Ograniczna wygenerowaną odpowiedź do podanej liczby tokenów.": "",
        "Ok": "",
        "Okładka": "",
        "Okładka do video premium": "",
        "Określa miejsce, w którym znajdzie się powiązany artykuł": "",
        "Określa z której strony do ścieżki mają być dodawane kolejne pozycje.": "",
        "Omnitool": "",
        "Opcja pozwala na przypisywanie do tej kategorii wydarzeń dodanych przez wszystkich użytkowników": "",
        "Opcje": "",
        "Open Graph": "",
        "OpenAI": "",
        "OpenAI o1": "",
        "OpenAI o1-mini": "",
        "Operacje": "",
        "Operacje wykonane": "",
        "Opiekun ścieżki": "",
        "Opinia": "",
        "Opis": "",
        "Opis błędu": "",
        "Opis funkcji": "",
        "Opis i media": "",
        "Opis kategorii": "",
        "Opis obrazka": "",
        "Opis obrazu": "",
        "Opis sekcji": "",
        "Opis spotkania": "",
        "Opis szkolenia": "",
        "Opis witryny": "",
        "Opis zespołu": "",
        "Opis źródła": "",
        "Opisy": "",
        "Opisz jaki formularz chcesz wygenerować": "",
        "Opłacone": "",
        "Opróżnij kategorię": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Opublikowana": "",
        "Opublikowane": "",
        "Opublikowane języki": "",
        "Opublikowane przez:": "",
        "Opublikowane wersje językowe.": "",
        "Opublikowany": "",
        "Opublikowany na stronach": "",
        "Opublikuj": "",
        "Opublikuj autora": "",
        "Opublikuj materiał": "",
        "Opublikuj ścieżkę szkoleniową aby móc dodać szkolenia": "",
        "Oraz hasło": "",
        "Oraz nowe hasło": "",
        "Organizacja": "",
        "Organizacja została usunięta.": "",
        "Osoba odpowiedzialna": "",
        "Osoba zastępowana": "",
        "Osoba zastępująca": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "Ostatnio aktualizowane": "",
        "Ostatnio oglądane": "",
        "Ostrzeżenia": "",
        "Ostrzeżenie": "",
        "Otwieraj w nowym oknie": "",
        "Otwórz": "",
        "Otwórz na nowej karcie": "",
        "Otwórz stronę w nowym oknie": "",
        "Otwórz w nowym oknie": "",
        "Oznacz": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie elementy szkolenia jako zaliczone": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Oznacz wybrane jako nieprzeczytane": "",
        "Oznacz wybrane jako przeczytane": "",
        "Paczka SCORM została dodana.": "",
        "Paczka SCORM została zaktualizowana.": "",
        "Paczka została usunięta.": "",
        "Paczki SCORM": "",
        "Paleta kolorów": "",
        "Paleta przycisków": "",
        "Pamięć podręczna": "",
        "Pamięć podręczna została wyczyszczona.": "",
        "Parameters": "",
        "Parametry": "",
        "Parametry funkcji": "",
        "Parametry wejściowe skryptu": "",
        "Parametry, wymagane do wykonania zapytania:": "",
        "Pasek": "",
        "Pasek postępu": "",
        "PayU": "",
        "październik": "",
        "Październik": "",
        "październiku": "",
        "Pełna strona": "",
        "Pełna treść:": "",
        "Pełny": "",
        "Pełny adres aktywnej strony": "",
        "Pełny adres wraz z \"http(s)://\".": "",
        "Pełny ekran": "",
        "Piątek": "",
        "Pierwiastkowanie wartości kolumny": "",
        "Pierwsza strona": "",
        "Pierwsza strona z listy jest identyfikowana przez system jako CANONICAL, czyli informuje roboty wyszukiwarki, która ze zduplikowanych stron jest tą z oryginalną treścią.": "",
        "Pierwsze zdjęcie w galerii jest zdjęciem głównym": "",
        "Pigułki": "",
        "Piktogram": "",
        "Pionowe": "",
        "Pionowo": "",
        "Piosenka": "",
        "Pisać mogą tylko zalogowani użytkownicy": "",
        "Plik": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik GIF": "",
        "Plik graficzny": "",
        "Plik HTML": "",
        "Plik jest wysyłany": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik PDF": "",
        "Plik PNG": "",
        "Plik skompresowany": "",
        "Plik wideo": "",
        "Plik z logami": "",
        "Plik ZIP": "",
        "Plik został dodany.": "",
        "Plik został pobrany.": "",
        "Plik został usunięty.": "",
        "Plik został wysłany": "",
        "Plik:": "",
        "Pliki": "",
        "Pliki Asystent": "",
        "Pliki asystenta": "",
        "Pliki Asystenta": "",
        "Pliki asystenta AI": "",
        "Pliki do dodania": "",
        "Pliki do wysłania: %0": "",
        "Pliki prywatne": "",
        "Pliki publiczne": "",
        "Pliki współdzielone": "",
        "Pliki: %0": "",
        "Płatności": "",
        "Płeć": "",
        "Płyta z muzyką": "",
        "po %0 nieudanych próbach logowania": "",
        "Po dodaniu szkoleń nie można zmienić publikacji.": "",
        "Po jednym synonimie w wierszu": "",
        "Po ustawieniu dat dostępów dla użytkowników w ścieżce będą one nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "",
        "Po ustawieniu indywidualnych dat dostępów dla użytkowników będą one nadrzędne, daty dostępów z zespołów nie będą brane pod uwagę.": "",
        "Po wybraniu tej opcji konta użytkowników zostaną usunięte z systemu. Czy chcesz kontynuować?": "",
        "Po zapisaniu wydarzenia nie można zmienić witryny i wersji językowej": "",
        "Po zaznaczeniu tej opcji uprawnienia indywidualne i pochodzące z ról nie są brane pod uwagę.": "",
        "Po zmianie krótkiego tytułu zmieni się również adres URL.": "",
        "Pobierz": "",
        "Pobierz certyfikat": "",
        "Pobierz plik": "",
        "Pobierz raport": "",
        "Pobierz wyniki": "",
        "Pochylenie": "",
        "Początkowa ilość wierszy": "",
        "Poczta": "",
        "Podaj adres url...": "",
        "Podaj identyfikatory użytkowników Facebooka, oddzielone przecinkami, aby mogli uzyskać dostęp do statystyk (Facebook Insights).": "",
        "Podaj kod weryfikacyjny": "",
        "Podaj liczbę pozycji": "",
        "Podaj nazwę formularza": "",
        "Podaj nazwę scenariusza": "",
        "Podaj nową nazwę": "",
        "Podaj swój adres email": "",
        "Podaj uwagi do treści, która ma zostać wygenerowana. Przykład: \"Używaj symboli matematycznych\".": "",
        "Podana nazwa jest zajęta.": "",
        "Podana wartość jest nieprawidłowa.": "",
        "Podanie nazwy jest wymagane.": "",
        "Podano adres": "",
        "Podano nieprawidłowe dane": "",
        "Podano nieprawidłowe dane.": "",
        "Podano nieprawidłowe dane. (%0)": "",
        "Podany adres e-mail został już dodany": "",
        "Podatek": "",
        "Podążanie za linkami": "",
        "Podczas definiowania szkolenia w prompcie zalecamy używanie następujących terminów:": "",
        "Podczas pierszego uruchomienia wymagane jest utworzenie konta głównego administratora.": "",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "",
        "Podczas przesyłania plików wystąpił nieznany błąd": "",
        "Podejście do elementu zostało zresetowane.": "",
        "Podgląd": "",
        "Podgląd formularza": "",
        "Podgląd listy": "",
        "Podgląd strony": "",
        "Podgląd tabeli": "",
        "Podkreślenie": "",
        "Podlega ocenie": "",
        "Podpis": "",
        "Podstawowe": "",
        "Podstawowe operacje na datach": "",
        "Podstawowe operacje na liczbach": "",
        "Podstawowe operacje tekstowe": "",
        "Podstawowe operacje warunkowe": "",
        "Podstawowy": "",
        "Podtytuł": "",
        "Podwójna": "",
        "Podwójna linia ciągła": "",
        "Podziedziałek - Piątek": "",
        "Pogrubienie": "",
        "Pogrubiona": "",
        "Pojedynczy artykuł (strona opisowa)": "",
        "Pojedynczy formularz": "",
        "Pojedynczy wybór": "",
        "Pojedyńcza, prosta, ciągła linia": "",
        "Pokaż dla wybranych zespołów lub użytkowników": "",
        "Pokaż etykietę": "",
        "Pokaż historię": "",
        "Pokaż numery stron": "",
        "Pokaż numery tygodnia na kalendarzu": "",
        "Pokaż przycisk 'Wyślij'": "",
        "Pokaż szczegóły": "",
        "Pokaż tylko moje dokumenty": "",
        "Pokaż tytuł formularza": "",
        "Pokaż tytuł sekcji": "",
        "Pokaż tytuł strony": "",
        "Pokaż tytuły stron": "",
        "Pokaż w koncie użytkownika": "",
        "Pokaż więcej": "",
        "pokaż więcej...": "",
        "Pokaż wszystkich użytkowników": "",
        "Pola takie jak \"Nazwa slajdu\", \"Kategoria materiału\", \"Typ materiału\" są uwzględniane przy automatycznym generowaniu treści, dlatego konieczne jest ich wypełnienie.": "",
        "Pole": "",
        "Pole \"%0\" jest wymagane.": "",
        "Pole \"%0\" jest wymagane. (%1)": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu email.": "",
        "Pole \"%0\" nie zawiera prawidłowego adresu URL.": "",
        "Pole \"%0\" wymaga uzupełnienia wszystkich elementów": "",
        "Pole \"%0\" zawiera niedozwoloną wartość.": "",
        "Pole \"%0\" zawiera nieprawidłowy symbol.": "",
        "Pole \"Drugie imię\" jest wymagane.": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Imię\" jest wymagane.": "",
        "Pole \"Liczba wyników na stronie\" jest wymagane.": "",
        "Pole \"Moduł dynamiczny\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Nazwisko\" jest wymagane.": "",
        "Pole \"Pole\" jest wymagane.": "",
        "Pole \"Sekcja modułu\" jest wymagane.": "",
        "Pole \"Szerokość\" jest wymagane.": "",
        "Pole \"Typ agregacji\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole \"Wysokość\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole jest wymagane.": "",
        "Pole może zawierać jedynie cyfry.": "",
        "Pole może zawierać jedynie cyfry. (%0)": "",
        "Pole może zawierać jedynie litery i cyfry.": "",
        "Pole może zawierać jedynie litery i cyfry. (%0)": "",
        "Pole może zawierać jedynie litery.": "",
        "Pole może zawierać jedynie litery. (%0)": "",
        "Pole może zawierać tylko ciało metody walidującej dane w postaci natywnego kodu JavaScript.": "",
        "Pole nie może zawierać spacji": "",
        "Pole skopiowane": "",
        "Pole tekstowe": "",
        "Pole typu \"%0\" jest niedozwolone w tym formularzu.": "",
        "Pole wymaga podania przynajmniej jednego znaku specjalnego.": "",
        "Pole wymaga podania przynajmniej jednej cyfry.": "",
        "Pole wymaga podania przynajmniej jednej dużej litery.": "",
        "Pole wymaga podania przynajmniej jednej małej litery.": "",
        "Pole wymagane": "",
        "Pole zawiera": "",
        "Polecane artykuły": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Połącz w pary": "",
        "Połączenie z API OpenAI jest aktywne.": "",
        "Połączenie z API OpenAI jest nieaktywne.": "",
        "Położenie tekstu w pionie": "",
        "Położenie tekstu w poziomie": "",
        "Pomoc": "",
        "Poniedziałek": "",
        "Poprawna odpowiedź": "",
        "Poprawne": "",
        "Poprawny": "",
        "Poprzedni": "",
        "Poprzednia strona": "",
        "Popularność": "",
        "Porównaj %0": "",
        "Porównaj z edytowaną wersją": "",
        "Porównania": "",
        "Porównanie": "",
        "Porównywana wersja": "",
        "Port": "",
        "Posiada załączniki": "",
        "Posiadasz niezapisane materiały": "",
        "POST: Dowolne wyszukiwanie (Zapytanie AQL)": "",
        "POST: Upload załączników": "",
        "POST: Utworzenie wpisu": "",
        "POST: Zapisanie zmian": "",
        "Postęp": "",
        "Postęp (%)": "",
        "Postępy": "",
        "Postępy użytkowników": "",
        "Potwierdzenia": "",
        "Potwierdzenie akceptacji": "",
        "Potwierdzenie archiwizacji": "",
        "Potwierdzenie archiwizacji. Archiwizacja tematu spowoduje zarchiwizowanie przypisanych do niego lekcji": "",
        "Potwierdzenie kopiowania": "",
        "Potwierdzenie przywrócenia": "",
        "Potwierdzenie przywrócenia szkolenia": "",
        "Potwierdzenie publikacji": "",
        "Potwierdzenie resetu podejścia do elementu szkolenia": "",
        "Potwierdzenie resetu podejścia do szkolenia": "",
        "Potwierdzenie ukrycia": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie usunięcia.": "",
        "Potwierdzenie wylogowania użytkownika": "",
        "Potwierdzenie zatwierdzenia": "",
        "Potwierdzenie zmiany statusu": "",
        "Potwierdź": "",
        "Potwierdź akceptację": "",
        "Potwierdź publikację wersji": "",
        "Potwierdź usunięcie": "",
        "Potwierdź usunięcie wybranej wersji aranżacji": "",
        "Potwierdź wyczyszczenie logów": "",
        "Potwierdź wyłączenie publikacji": "",
        "Potwierdź zapis do aktualnej wersji": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienia z linkiem rejestracyjnym nie zostaną wysłane, ponieważ ten typ powiadomień nie jest obecnie włączony w platformie.": "",
        "Powiadomienia zostały skonfigurowane.": "",
        "Powiadomienie dla administratora chatu o nowych wiadomościach": "",
        "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "",
        "Powiadomienie o oczekującym szkoleniu": "",
        "Powiadomienie o zbliżającym się zakończeniu szkolenia": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Powiązana galeria": "",
        "Powiązana kategoria": "",
        "Powiązana kontrolka": "",
        "Powiązane artykuły": "",
        "Powiązane galerie": "",
        "Powiązane kategorię": "",
        "Powiązane wideo": "",
        "Powiązane wydziały": "",
        "Powiązany artykuł": "",
        "Powiązany autor": "",
        "Powiększ": "",
        "Powinno się dodać dyrektywę PRIVATE dla treści personalizowanych dla użytkownika, zwłaszcza dla odpowiedzi otrzymywanych po zalogowaniu i z uwzględnieniem uprawnień.": "",
        "Powód": "",
        "powrót": "",
        "Powrót": "",
        "Powtarzaj co": "",
        "Powtórz hasło": "",
        "Powtórzenia": "",
        "Powtórzone": "",
        "Powyższe obiekty zawierają tylko właściwości i są pozbawione wszystkich metod.": "",
        "Poziom dostępu do webhooka": "",
        "Poziom dostępu użytkownika": "",
        "Poziom logowania błedów": "",
        "Poziome": "",
        "Poziomo": "",
        "Poziomy logowania": "",
        "Pozostałe": "",
        "Pozostałe ustawienia": "",
        "Pozostało %0 znaków.": "",
        "Pozwól kontynuować na obecnej wersji": "",
        "Pozwól na dodawanie wierszy": "",
        "Pozwól na sortowanie wierszy": "",
        "Pozycja": "",
        "Pozycja na liście": "",
        "Pozycje zostały zapisane.": "",
        "pół roku": "",
        "Prawda-Fałsz": "",
        "Prawo": "",
        "Prawy panel": "",
        "Predefiniowane tła panelu z aplikacjami": "",
        "Predefiniowane zestawy kolorów": "",
        "Premiera": "",
        "Premium": "",
        "Premium otwarty": "",
        "Prezentacja": "",
        "Priorytet": "",
        "private (tylko cache przeglądarki)": "",
        "Procent": "",
        "Proces": "",
        "Produkcyjne": "",
        "Produkt nie został usunięty. Należy do kolekcji:": "",
        "Produkt promowany": "",
        "Produkt został dodany.": "",
        "Produkt został usunięty.": "",
        "Produkt został zaktualizowany.": "",
        "Produkty": "",
        "Profil koordynatora": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Program": "",
        "Program szkolenia": "",
        "Projekt": "",
        "Prometheus": "",
        "Promowany": "",
        "Proporcje obrazu": "",
        "Prosta": "",
        "Proste uprawnienia": "",
        "Protokół OAuth - client_id": "",
        "Protokół OAuth - client_secret": "",
        "Próbkowanie": "",
        "Próg": "",
        "Próg zaliczenia (%)": "",
        "Prywatne": "",
        "Prywatny": "",
        "Przebudowanie indeksów": "",
        "Przebudowanie indeksównnOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.nnNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "",
        "Przeciągnij do innej sekcji": "",
        "Przeciągnij do wybranej sekcji": "",
        "Przeciągnij i upuść aby posortować pliki": "",
        "Przeczytane": "",
        "Przedrostek": "",
        "Przedtytuł": "",
        "Przeglądanie logów aktywności": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "Przeglądnij logi": "",
        "Przeindeksowanie danych": "",
        "Przeindeksowanie danychnnOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.nnNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "",
        "Przejdź do kolejnego kroku gdy:": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Przekierowania": "",
        "Przekierowanie aktywne": "",
        "Przekierowanie zostało dodane.": "",
        "Przekierowanie zostało usunięte.": "",
        "Przekierowanie zostało zaktualizowane.": "",
        "Przekreślenie": "",
        "Przekroczono dozwoloną ilość znaków: %0.": "",
        "Przekroczono dozwoloną ilość znaków: %0. (%1)": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przelew tradycyjny": "",
        "Przelewy24": "",
        "Przełącznik": "",
        "Przeniesienie wpisu do kosza": "",
        "Przeniesienie wybranych elementów": "",
        "przeniesiony do kosza": "",
        "Przenieś": "",
        "Przenieś do sekcji": "",
        "Przenieś niżej": "",
        "Przenieś wyżej": "",
        "Przenieś${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "przeniósł do kosza": "",
        "Przepisz aktualne stawki za 1000 tokenów z cennika OpenAI.": "",
        "Przepisz aktualne stawki za milion tokenów z cennika Azure OpenAI.": "",
        "Przepisz aktualne stawki za milion tokenów z cennika OpenAI.": "",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika Azure OpenAI.": "",
        "Przepisz aktualne stawki za tysiąc tokenów z cennika OpenAI.": "",
        "Przepisz limit konta OpenAI.": "",
        "Przepnij alias": "",
        "Przerwany": "",
        "Przerywana": "",
        "Przesuń do góry": "",
        "Przesuń na dół": "",
        "Przesuń w dół": "",
        "Przesyłanie plików powiodło się.": "",
        "Przetestuj": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetestuj ustawienia Sms": "",
        "Przetwarzane": "",
        "przez": "",
        "Przybliżenie": "",
        "Przybornik": "",
        "Przycisk \"zobacz wszystkie\" znajdujący się przy bloczku, będzie przekierowywał na wybraną stronę z szkoleniami. Jeśli strona nie zostanie wybrana zostanie on ukryty.": "",
        "Przyciski": "",
        "Przykład": "",
        "Przykład:": "",
        "Przykład: domena\\użytkownik": "",
        "Przykład: użytkownik@domena": "",
        "Przykładowa struktura danych": "",
        "Przykładowa struktura do rozbudowy/modyfikacji": "",
        "Przykładowy prompt": "",
        "Przykładowy prompt ": "",
        "Przykłady": "",
        "Przykłady konfiguracji": "",
        "Przypisanie do zespołu": "",
        "Przypisanie ról": "",
        "Przypisz użytkowników do terminu spotkania, aby móc ich wyszukać.": "",
        "przypisz wynik etapu...": "",
        "Przypisz zespoły do terminu spotkania, aby móc je wyszukać.": "",
        "Przypomnienie": "",
        "Przyrostek": "",
        "Przywrócenie": "",
        "Przywrócenie wpisu z kosza": "",
        "Przywrócić użytkownika i jego wiadomości?": "",
        "Przywrócić wiadomość?": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przywróć": "",
        "Przywróć domyślne": "",
        "Przywróć filtr": "",
        "Przywróć ustawienia domyślne reguł i celów": "",
        "Przywróć użytkownika": "",
        "Przyznaj dostęp": "",
        "Przyznawanie punktów": "",
        "Pseudonim": "",
        "public (cache przeglądarki i proxy)": "",
        "Publiczne": "",
        "Publiczne ID:": "",
        "Publiczny": "",
        "Publikacja": "",
        "Publikacja aranżacji została wyłączona.": "",
        "Publikacja galerii przez użytkownika": "",
        "Publikacja i przypisane szkolenia zostały usunięte.": "",
        "Publikacja priorytetowa": "",
        "Publikacja zarchiwizowana": "",
        "Publikacja została dodana.": "",
        "Publikacja została usunięta.": "",
        "Publikuj do": "",
        "Publikuj na stronie": "",
        "Publikuj od": "",
        "Publikuj spotkanie": "",
        "Publikuj szkolenie": "",
        "Publikuj ścieżkę szkoleniową": "",
        "Publikuj termin": "",
        "Punkty": "",
        "Punkty za ukończenie": "",
        "Punkty zostały dodane.": "",
        "Punkty zostały zaktualizowane. Zmiana dotyczy tylko nowo zdobytych punktów.": "",
        "PUT: Aktualizacja wpisu": "",
        "Pytania": "",
        "Pytania i odpowiedzi": "",
        "Pytanie": "",
        "Pytanie i odpowiedzi": "",
        "Query string": "",
        "Radio": "",
        "Ranga": "",
        "Raporty": "",
        "Raporty certyfikatów": "",
        "Raporty szkoleniowe": "",
        "Recaptcha": "",
        "ReCaptcha": "",
        "Redaktor został zaktualizowany.": "",
        "Region": "",
        "Regulamin wymagany": "",
        "Regulamin został dodany.": "",
        "Regulamin został zaktualizowany.": "",
        "Regulaminy": "",
        "Regularna": "",
        "Reguła": "",
        "Reguła filtracyjna": "",
        "Reguła końcowa": "",
        "Reguła został dodana.": "",
        "reguła została usunięta.": "",
        "Reguła została zaktualizowana.": "",
        "Reguły": "",
        "Rejestr zmian": "",
        "Rejestracja konta": "",
        "Relacyjne": "",
        "Repozytorium plików": "",
        "Request body": "",
        "Reset podejścia do szkolenia": "",
        "Resetowanie podejść": "",
        "Resetowanie podejść użytkowników": "",
        "Resetuj": "",
        "Resetuj licznik": "",
        "Resetuj zmiany": "",
        "RESTful API": "",
        "Rezultat": "",
        "Rezygnacja": "",
        "Reżyseria": "",
        "Ręczna akceptacja wszystkich komentarzy": "",
        "Rocznie": "",
        "Roczny": "",
        "Rodzaj adresu kanonicznego": "",
        "Rodzaj odpowiedzi": "",
        "Rodzaj wydarzenia": "",
        "Rodzaj źródła": "",
        "rok": "",
        "Rok": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zespołu": "",
        "Role zostały przypisane": "",
        "Root": "",
        "Rotator": "",
        "Rotator został dodany.": "",
        "Rotator został usunięty.": "",
        "Rotator został zaktualizowany.": "",
        "Rotatory opinii": "",
        "Rozdzielczość": "",
        "Rozdzielczość obrazu: 1024x1024": "",
        "Rozdzielczość obrazu: 1024x1792 lub 1792x1024": "",
        "Rozdzielczość wygnerowanego obrazu.": "",
        "Rozmiar": "",
        "Rozmiar czcionki": "",
        "Rozmiar okna popup": "",
        "Rozmiar pliku": "",
        "Rozmiar podawany w bajtach.": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "Rozmieść równomiernie": "",
        "Rozpoczęcie spotkania": "",
        "Rozpoczęcie szkolenia": "",
        "Rozszerzony - błedy ważne": "",
        "Rozwijana lista - accordion": "",
        "Rozwiń do": "",
        "Równość": "",
        "RSS": "",
        "Satysfakcja": "",
        "Scenariusz": "",
        "Scenariusz aktywny": "",
        "Scenariusz został dodany.": "",
        "Scenariusz został usunięty.": "",
        "Scenariusz został utworzony.": "",
        "Scenariusz został zaktualizowany.": "",
        "Scorm": "",
        "SCORM": "",
        "Scrollowalne okna popup": "",
        "Secret ID": "",
        "Sekcja": "",
        "Sekcja %0": "",
        "Sekcja modułu": "",
        "Sekcja pod artykułem": "",
        "Sekcja śródtekstowa": "",
        "Sekcje": "",
        "Sekcje dla gości": "",
        "Sekcje dla zalogowanych": "",
        "Sekcje i bloki": "",
        "Sekcje wspólne": "",
        "Sekundy": "",
        "Selektor ikony": "",
        "Selektor kolorów": "",
        "SenderId": "",
        "Sentry": "",
        "Separator elementów w tytule": "",
        "Seq": "",
        "Serial telewizyjny": "",
        "Serie kresek lub fragmentów linii": "",
        "Serie kropek": "",
        "Server Side Cache": "",
        "Serwer bazy danych": "",
        "Serwer dostępny": "",
        "Serwer plików": "",
        "Serwer został dodany.": "",
        "Serwer został usunięty.": "",
        "Serwer został zaktualizowany.": "",
        "Serwery plików": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja użytkownika": "",
        "Sheduler": "",
        "sierpień": "",
        "Sierpień": "",
        "sierpniu": "",
        "Sitemap": "",
        "Skala 1-5": "",
        "Skala odliczania": "",
        "Sklep": "",
        "Skopiowano": "",
        "Skopiuj szkolenie": "",
        "Skrócony opis": "",
        "Skrypt (C#)": "",
        "Skrypty zewnętrzne": "",
        "Skrypty związane ze zbieraniem danych targetujących, np. Google Tag Manager, Pixel Facebook. Dodawany w górnej części <body> witryny.": "",
        "Skrypty związane ze zbieraniem statystyk przez usługi zewnętrzne, np. Analytics, Matomo. Dodawany w górnej części <head> witryny.": "",
        "Slajd do powtórzenia": "",
        "Slajd z materiałów szkoleniowych": "",
        "Slajd został dodany.": "",
        "Slajd został usunięty.": "",
        "Slajd został wygenerowany.": "",
        "Slajd został zaktualizowany.": "",
        "Slajder": "",
        "Slajder został dodany.": "",
        "Slajder został usunięty.": "",
        "Slajder został zaktualizowany.": "",
        "Slajdery": "",
        "Slajdy": "",
        "Slajdy zostały zaimportowane.": "",
        "słowa": "",
        "Słowa kluczowe": "",
        "Słowa oddzielone przecinkami.": "",
        "Słowa wykluczone": "",
        "Słownik": "",
        "Słownik dowolny": "",
        "Słownik systemowy": "",
        "Słowo": "",
        "Słowo bazowe": "",
        "Słowo wykluczone": "",
        "Słowo zostało dodane.": "",
        "Słowo zostało usunięte.": "",
        "Słowo zostało zaktualizowane.": "",
        "Sobota": "",
        "Sortowanie": "",
        "Sortowanie autorów": "",
        "Sortowanie kategorii": "",
        "Sortuj autorów": "",
        "Sortuj kategorie": "",
        "Specjalizowane": "",
        "Specyfikacja": "",
        "Sposób płatności włączony": "",
        "Sposób płatności został dodany.": "",
        "Sposób płatności został usunięty.": "",
        "Sposób płatności został zaktualizowany.": "",
        "Sposób prezentacji zakładek": "",
        "Spotkania": "",
        "Spotkanie": "",
        "Spotkanie do": "",
        "Spotkanie od": "",
        "Spotkanie zostało dodane.": "",
        "Spotkanie zostało usunięte.": "",
        "Spotkanie zostało zaktualizowane.": "",
        "Sprawdzenie czy pusty": "",
        "Sprawdź poprawność wprowadzonych danych. Po zapisaniu kolumna Zaliczenie testu nie będzie edytowalna, ponieważ zostanie wygenerowany certyfikat. Czy zapisać dane?": "",
        "Stała wartość": "",
        "Stan": "",
        "Stan powiadomienia": "",
        "Standard": "",
        "Standard 1.2": "",
        "Standard 2004": "",
        "Standard nieznany": "",
        "Standardowa strona": "",
        "Standardowa szczegółowość": "",
        "Standardowe uprawnienia": "",
        "Standardowy": "",
        "Stanowiska": "",
        "Stanowisko": "",
        "Stanowisko pracy": "",
        "Stanowisko zostało dodane.": "",
        "Stanowisko zostało usunięte.": "",
        "Stanowisko zostało zaktualizowane.": "",
        "Start": "",
        "Status": "",
        "Status aranżacji został zmieniony.": "",
        "Status dokumentu został zmieniony.": "",
        "Status edytowanej wersji dokumentu": "",
        "Status galerii został zmieniony.": "",
        "Status linku został zmieniony.": "",
        "Status modułu": "",
        "Status paczki został zmieniony.": "",
        "Status płatności": "",
        "Status powiadomienia": "",
        "Status realizacji": "",
        "Status regulaminu został zmieniony.": "",
        "Status webhooka": "",
        "Status wideo został zmieniony.": "",
        "Status został zmieniony dla ": "",
        "Status żądania": "",
        "Status:": "",
        "Statyczny": "",
        "Statystyki wykorzystania tokenów.": "",
        "Stopka": "",
        "String": "",
        "Strona": "",
        "Strona %0": "",
        "Strona błędu": "",
        "Strona docelowa dla 'Czytaj więcej'": "",
        "Strona docelowa dla 'Kontakt z adminem'": "",
        "Strona docelowa dla 'Pliki cookies'": "",
        "Strona docelowa dla 'Polityka prywatności'": "",
        "Strona dostępna dla wszystkich": "",
        "Strona dostępna tylko dla zalogowanych użytkowników": "",
        "Strona główna": "",
        "Strona lekcji opublikowana": "",
        "Strona lekcji SCORM opublikowana": "",
        "Strona logowania": "",
        "Strona nadrzędna": "",
        "Strona opublikowana": "",
        "Strona szkolenia ukryta": "",
        "Strona testu opublikowana": "",
        "Strona ukryta": "",
        "Strona z błędem 404": "",
        "Strona z modułu konto użytkownika": "",
        "Strona z modułu wyszukiwarki": "",
        "Strona została dodana.": "",
        "Strona została usunięta.": "",
        "Strona została zaktualizowana.": "",
        "Strona została zarchiwizowana.": "",
        "Strony": "",
        "Struktura organizacyjna": "",
        "Struktura serwisu": "",
        "Struktura szkolenia": "",
        "Studio": "",
        "Stwierdzenia": "",
        "Stwierdzenie": "",
        "styczeń": "",
        "Styczeń": "",
        "styczniu": "",
        "Styl": "",
        "Styl obrazu": "",
        "Subskrypcja": "",
        "Subskrypcja aktywna": "",
        "Subskrypcje": "",
        "Sukces": "",
        "Suma": "",
        "Suma danych wejściowych i wyjściowych podana w tokenach.": "",
        "Suma tokenów": "",
        "Suma zużytych tokenów": "",
        "Symbol": "",
        "Symbol autora": "",
        "Symbol jest wymagany": "",
        "Symbol jest zajęty": "",
        "Symbol klienta": "",
        "Symbol lekcji": "",
        "Symbol modułu": "",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
        "Symbol musi mieć co najmniej 3 znaki": "",
        "Symbol musi mieć co najmniej 5 znaków": "",
        "Symbol nie może być dłuższy niż 10 znaków": "",
        "Symbol nie może być dłuższy niż 20 znaków": "",
        "Symbol strony": "",
        "Symbol strony spotkania": "",
        "Symbol strony szkolenia": "",
        "Symbol testu": "",
        "Symbol w adresie URL": "",
        "Symbol waluty został zaktualizowany.": "",
        "Synchronizuj": "",
        "Synonimy": "",
        "Synonimy zostały dodane.": "",
        "Synonimy zostały usunięte.": "",
        "Synonimy zostały zaktualizowane.": "",
        "System": "",
        "System powiadomień": "",
        "Szablon": "",
        "Szablon graficzny": "",
        "Szablon importu": "",
        "Szablon modułu": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony": "",
        "Szablony powiadomień": "",
        "Szacowana kwota:": "",
        "Szary": "",
        "Szczegółowość obrazu": "",
        "Szczegółowy - błedy krytyczne": "",
        "Szczegóły": "",
        "Szczegóły asystenta": "",
        "Szczegóły elementu": "",
        "Szczegóły kolekcji": "",
        "Szczegóły pliku": "",
        "Szczegóły szkolenia": "",
        "Szczegóły zadania": "",
        "Szczegóły zapytania": "",
        "Szczegóły zdarzenia": "",
        "Szczegóły zdarzenia nr %0": "",
        "Szerokość": "",
        "Szerokość [%": "",
        "Szerokość geograficzna": "",
        "Szkic": "",
        "szkolenia": "",
        "Szkolenia": "",
        "szkolenie": "",
        "Szkolenie": "",
        "Szkolenie cykliczne": "",
        "Szkolenie jest puste": "",
        "Szkolenie może występować tylko w jednej ścieżce. To szkolenie zostało już dodane do ścieżki: {0}": "",
        "Szkolenie powinno zawierać 1 temat, 2 lekcje, a w każdej lekcji po 3 slajdy. Po każdej lekcji powinien być test składający się z 2 pytań jednokrotnego wyboru.": "",
        "Szkolenie w liczbach": "",
        "Szkolenie zostało dodane.": "",
        "Szkolenie zostało przywrócone.": "",
        "Szkolenie zostało skopiowane": "",
        "Szkolenie zostało wygenerowane": "",
        "Szkolenie zostało zaktualizowane.": "",
        "Szkolenie zostało zaliczone. Nie można go edytować.": "",
        "Szkolenie zostało zarchiwizowane.": "",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "",
        "Szkoleniowe": "",
        "szkoleń": "",
        "Szkoleń": "",
        "Sztuczna inteligencja": "",
        "Szukaj": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukana fraza": "",
        "Szukane słowo": "",
        "Ścieżka": "",
        "Ścieżka aktywnej strony": "",
        "Ścieżka cykliczna": "",
        "Ścieżka już jest opublikowana.": "",
        "Ścieżka nawigacyjna": "",
        "Ścieżka szkoleniowa": "",
        "Ścieżka szkoleniowa została dodana.": "",
        "Ścieżka szkoleniowa została usunięta.": "",
        "Ścieżka szkoleniowa została zaktualizowana.": "",
        "Ścieżka/strona:": "",
        "Średni": "",
        "Średni tekst": "",
        "Średnia": "",
        "Środa": "",
        "Środek": "",
        "Środowisko": "",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "",
        "Ta opcja dodaje użytkownika do wszystkich zespołów z zaznaczoną opcją Lidera i pozwala koordynatorowi widzieć wszystko w profilu koordynatora. Również do nowo utworzonych zespołów będzie  on ustawiał się jako Lider.": "",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tabela": "",
        "Tagi": "",
        "tak": "",
        "Tak": "",
        "Tak/Nie": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Tekst do uzupełnienia": "",
        "Tekst lokalizowany": "",
        "Tekst zastępczy": "",
        "Tekstowy / HTML / JS": "",
        "Telefon": "",
        "Temat": "",
        "Tematy": "",
        "Ten dashboard nie zawiera jeszcze żadnych widgetów": "",
        "Ten dashboard nie zawiera żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "",
        "Tenant ID": "",
        "Teraz": "",
        "Termin cykliczny": "",
        "Termin jednorazowy": "",
        "Termin posiada test": "",
        "Termin spotkania: ": "",
        "Termin został dodany.": "",
        "Termin został usunięty.": "",
        "Termin został zaktualizowany.": "",
        "Terminy": "",
        "Terminy do słownika będzie można dodawać dopiero po zapisaniu źródła danych.": "",
        "Test": "",
        "Test konfiguracji": "",
        "Test nie może zawierać materiałów opisowych i materiałów video": "",
        "Test ukryty": "",
        "Test ustawień": "",
        "Test ustawień pomyślnie zakończony.": "",
        "Test został dodany.": "",
        "Test został zaktualizowany.": "",
        "Testowe": "",
        "Testowy adres email": "",
        "Testowy numer telefonu": "",
        "Testuj": "",
        "Testuj zapytanie": "",
        "Testy": "",
        "Tło": "",
        "Tło aktywnej zakładki": "",
        "Tło certyfikatu": "",
        "Tło przycisku": "",
        "Tło strona 2": "",
        "Tłumaczenia": "",
        "To pole jest wymagane": "",
        "To szkolenie znajduje się już w ścieżce szkoleń": "",
        "Token": "",
        "Token został usunięty.": "",
        "Tokeny": "",
        "Tokeny dostępu": "",
        "Tokeny wejściowe": "",
        "Tokeny wyjściowe": "",
        "Top temat został dodany.": "",
        "Top temat został usunięty.": "",
        "Top temat został zaktualizowany.": "",
        "Top tematy": "",
        "Trace - najwięcej szczegółów": "",
        "Tracing": "",
        "Treści odpowiedzi są wymagane": "",
        "Treści pytań są wymagane": "",
        "Treść": "",
        "Treść certyfikatu": "",
        "Treść instrukcji": "",
        "Treść komentarza": "",
        "Treść nie może być pusta.": "",
        "Treść przycisku": "",
        "Trigger": "",
        "True": "",
        "Trwa generowanie formularza": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Trwa generowanie planu szkolenia, może to potrwać kilka minut.": "",
        "Tryb konserwacji systemu": "",
        "Tryb monitorowania aktywności": "",
        "Tryb monitorowania aktywności włączony.": "",
        "Tryb monitorowania aktywności wyłączony.": "",
        "Tryb prezentacyjny": "",
        "Tryb wyświetlania": "",
        "Trzy kolumny": "",
        "tutaj": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Tworzenie dokumentów": "",
        "Tworzenie szkoleń w kreatorze AI": "",
        "Twój token": "",
        "tydzień": "",
        "Tydzień": "",
        "tydzień (tygodnie) w następującym dniu": "",
        "Tygodniowy": "",
        "Tylko 404": "",
        "Tylko aktywne": "",
        "Tylko do odczytu": "",
        "tylko dokumenty wersjonowane": "",
        "Tylko gdy odpowiedź serwera jest 404": "",
        "Tylko liderzy": "",
        "Tylko małe litery, bez znaków specjalnych, cyfr i spacji.": "",
        "Tylko moje": "",
        "Tylko priorytetowe": "",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "",
        "Tylko treść": "",
        "Tylko zalogowani użytkownicy mogą zgłaszać komentarze": "",
        "Typ": "",
        "Typ agregacji": "",
        "Typ aranżacji": "",
        "Typ autora": "",
        "Typ bannera": "",
        "Typ elementu": "",
        "Typ konta": "",
        "Typ kontentu": "",
        "Typ linku": "",
        "Typ logowania": "",
        "Typ materiału": "",
        "Typ mime": "",
        "Typ obiektu": "",
        "Typ obiektu:": "",
        "Typ obiektu.": "",
        "Typ pliku": "",
        "Typ płatności": "",
        "Typ pola": "",
        "Typ powiadomienia": "",
        "Typ rankingu": "",
        "Typ serwera": "",
        "Typ slajdu": "",
        "Typ słownika": "",
        "Typ spotkania": "",
        "Typ strony": "",
        "Typ właściwy": "",
        "Typ zestawu": "",
        "Typ zmiennej": "",
        "Typ źródła": "",
        "Typ źródła danych": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Typy materiałów": "",
        "Tytuł": "",
        "Tytuł aktywnej witryny": "",
        "Tytuł formularza jest wymagany": "",
        "Tytuł formularza nie może być dłuższy niż %0 znaków": "",
        "Tytuł kafelka": "",
        "Tytuł okładki": "",
        "Tytuł powiadomienia": "",
        "Tytuł sekcji": "",
        "Tytuł strony": "",
        "Tytuł witryny": "",
        "Udało się zapisać ustawienia widgetów": "",
        "Układ": "",
        "Układ listy": "",
        "Ukryj": "",
        "Ukryj materiał": "",
        "Ukryta": "",
        "Ukryty": "",
        "Ulica": "",
        "Ułożenie": "",
        "Umożliwienie sprawdzania odpowiedzi": "",
        "Uniksowy znacznik czasu utworzenia zakończenia czatu.": "",
        "Upload": "",
        "Uprawnienia": "",
        "Uprawnienia do dokumentów": "",
        "Uprawnienia do szkolenia pochodzą z terminu spotkań.": "",
        "Uprawnienia użytkownika": "",
        "Uprawnienia zostały usunięte.": "",
        "Url": "",
        "URL": "",
        "Uruchom nagranie automatycznie": "",
        "Uruchom zadanie": "",
        "Urządzenie zostało usunięte.": "",
        "Usage": "",
        "Usługi": "",
        "Ustaw domyślny poziom logowania. Logi poniżej tego poziomu nie bądą zbierane niezależnie od pozostałych ustawień.": "",
        "Ustaw filtry aby wygenerować raport": "",
        "Ustaw kategorię": "",
        "Ustaw kolor po najechaniu myszką": "",
        "Ustaw poziomy logów które będą wysyłane do poszczególnych rejestrów.": "",
        "Ustaw poziomy logów które będą zbierane z poszczególnych przestrzeni nazw.": "",
        "Ustaw również dla wszystkich podstron": "",
        "Ustaw status": "",
        "Ustaw szerokości proporcjonalnie": "",
        "Ustaw w kolejności": "",
        "Ustawienia": "",
        "Ustawienia domyślne": "",
        "Ustawienia dostępności": "",
        "Ustawienia Firebase": "",
        "Ustawienia konta": "",
        "Ustawienia lini poziomej": "",
        "Ustawienia ogólne": "",
        "Ustawienia PayU": "",
        "Ustawienia podstawowe": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Ustawienia przelewu tradycyjnego": "",
        "Ustawienia Przelewy24": "",
        "Ustawienia redakcji": "",
        "Ustawienia rotatora": "",
        "Ustawienia sekcji \"%0\"": "",
        "Ustawienia slajdera": "",
        "Ustawienia strony": "",
        "Ustawienia widgetów zostały zapisane": "",
        "ustawienia widgetu": "",
        "Ustawienia widgetu": "",
        "Ustawienia witryny": "",
        "Ustawienia zaawansowane": "",
        "Ustawienia zakładek": "",
        "Ustawienia zostały zaktualizowane.": "",
        "Ustawienia zostały zapisane.": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "Usunięcie dokumentu": "",
        "Usunięcie formularzannOperacja jest nieodwracalna. Zostaną utracone wszystkie powiązane dokumenty!nnCzy na pewno chcesz usunąć wybrany formularz?": "",
        "Usunięcie indeksunnOperacja jest nieodwracalna. Czy na pewno chcesz usunąć wybrany indeks?": "",
        "Usunięcie wpisu": "",
        "Usunięcie wybranych elementów": "",
        "Usunięte": "",
        "Usunięto wątek.": "",
        "Usunięto wybraną wersję aranżacji.": "",
        "usunięty": "",
        "Usuń": "",
        "Usuń artykuł z listy": "",
        "Usuń autora": "",
        "Usuń blok z sekcji": "",
        "Usuń datę": "",
        "Usuń dział": "",
        "Usuń element": "",
        "Usuń filtr": "",
        "Usuń grupę": "",
        "Usuń indeks": "",
        "Usuń kafelek": "",
        "Usuń katalog": "",
        "Usuń kategorię": "",
        "Usuń kolor": "",
        "Usuń logi gdy wykonywanie scenariusza": "",
        "Usuń nie zapisany materiał z lekcji": "",
        "Usuń nie zapisany materiał z testu": "",
        "Usuń obrazek": "",
        "Usuń odpowiedź": "",
        "Usuń opinię": "",
        "Usuń parametr": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń poprzednie wersje certyfikatu": "",
        "Usuń powiązanie": "",
        "Usuń powód": "",
        "Usuń pozycję": "",
        "Usuń produkt": "",
        "Usuń publikację": "",
        "Usuń punkt": "",
        "Usuń pytanie": "",
        "Usuń regulamin": "",
        "Usuń sekcję": "",
        "Usuń slajd": "",
        "Usuń słowo": "",
        "Usuń spacje": "",
        "Usuń stronę": "",
        "Usuń szkolenie z ścieżki szkoleń": "",
        "Usuń tag": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie aby odwołać zapamiętane automatyczne logowanie na swoje konto": "",
        "Usuń wątek": "",
        "Usuń wiersz": "",
        "Usuń wybraną wersję aranżacji": "",
        "Usuń wydarzenie": "",
        "Usuń z terminu": "",
        "Usuń z zespołu": "",
        "Usuń ze szkolenia": "",
        "Usuń zestaw": "",
        "Usuń${selected.length > 1 ? ' zaznaczone' : ''}": "",
        "Usuwanie dokumentów": "",
        "Usuwanie użytkowników": "",
        "Usuwanie własnych dokumentów": "",
        "Usuwanie wszystkich dokumentów": "",
        "Utworzenie wpisu": "",
        "Utworzono wątek.": "",
        "Utworzył": "",
        "Utwórz formularz": "",
        "Utwórz grupy": "",
        "Utwórz katalog": "",
        "Utwórz kopię formularza": "",
        "Utwórz kopię z": "",
        "Utwórz nowy": "",
        "Utwórz nowy wątek": "",
        "Utwórz scenariusz": "",
        "Utwórz wątek": "",
        "UWAGA: Brak obsługi TypeScript oraz w kodzie metody nie można robić importów.": "",
        "Uwzględnij wydziały podrzędne": "",
        "Uzupełnij dane dotyczące szkolenia": "",
        "Uzupełnij luki": "",
        "Uzupełnij wymagane pola.": "",
        "Użyj domyślnego zapytania SQL": "",
        "Użyte narzędzie": "",
        "Użytkownicy": "",
        "Użytkownicy mogą zgłaszać komentarze do moderacji": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik i jego wiadomości zostały przywrócone.": "",
        "Użytkownik jest liderem zespołu": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "",
        "Użytkownik nie należy do żadnego zespołu.": "",
        "Użytkownik posiada pełne uprawnienia": "",
        "Użytkownik usunięty z zespołu": "",
        "Użytkownik z bazy": "",
        "Użytkownik z zespołu zostali dodani.": "",
        "Użytkownik zalogowany": "",
        "Użytkownik został dodany do zespołu.": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został przypisany do szkolenia.": "",
        "Użytkownik został przypisany do ścieżki szkoleniowej.": "",
        "Użytkownik został przypisany do terminu.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zablokowany, a jego wiadomośći ukryte.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkownik został zanonimizowany.": "",
        "Użytkownikcy z bazy": "",
        "Użytkowników": "",
        "Użyty Model": "",
        "Video": "",
        "W ciągu ostatniego tygodnia nie dodano nowych użytkowników": "",
        "W ciele metody walidującej dostępne są poniższe zmienne:": "",
        "W każdy dzień tygodnia": "",
        "W następującym dniu:": "",
        "W organizacji nie ma jeszcze żadnych działów.": "",
        "W przypadku braku wartości zostanie wyświetlona nazwa strony.": "",
        "W przyszłości": "",
        "W trakcie": "",
        "W trakcie weryfikacji": "",
        "w tym ": "",
        "W tym katalogu nie ma jeszcze żadnych stron.": "",
        "W zespole od %0": "",
        "W zespole od %0 do %1": "",
        "Walidacja": "",
        "Walidacja certyfikatu SSL": "",
        "Walidacja danych": "",
        "Walidacja po stronie API": "",
        "Walidacja typów MIME": "",
        "Waluta": "",
        "Warn - ostrzeżenia": "",
        "Warto stosować przejrzystą hierarchię elementów, ułatwiającą AI interpretację i generowanie treści.": "",
        "Wartości od 0 - 1.0 (0 oznacza 0%, a 1 oznacza 100%)": "",
        "Wartość": "",
        "Wartość 0 oznacza brak limitu": "",
        "Wartość brutto": "",
        "Wartość domyślna": "",
        "Wartość domyślna oznacza, że użytkownik może zaliczyć element od razu po odtworzeniu zasobu": "",
        "Wartość domyślna: (&(objectClass=organizationalUnit))": "",
        "Wartość domyślna: (&(objectClass=user)": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Wartość netto": "",
        "Wartość nie może byc mniejsza niż 0": "",
        "Wartość tekstowa": "",
        "Wartość zamówienia (brutto)": "",
        "Wartość zamówienia (netto)": "",
        "Wartość zmiennej": "",
        "Warunek": "",
        "Warunek nie zostanie spełniony": "",
        "Warunek zostanie spełniony": "",
        "Warunki korzystania z usług Google": "",
        "Warunki logiczne": "",
        "Warunkowo": "",
        "Ważne informacje": "",
        "Ważność": "",
        "Wątek": "",
        "Wątek główny": "",
        "Wątek główny jest kontynuowany automatycznie przez asystenta.": "",
        "Wątek nie zawiera jeszcze żadnych wiadomości": "",
        "Wątki wiadomości": "",
        "Wczytywanie danych...": "",
        "Webhook": "",
        "Webhook został dodany.": "",
        "Webhook został usunięty.": "",
        "Webhook został zaktualizowany.": "",
        "Webhooki": "",
        "Webinar": "",
        "Weekend": "",
        "Wersja API": "",
        "Wersja językowa": "",
        "Wersja modelu": "",
        "Wersja modelu GPT.": "",
        "Wersja nieopublikowana": "",
        "Wersja opublikowana": "",
        "Wersja utowrzona przez": "",
        "Wersje": "",
        "Wersje aranżacji": "",
        "Wersje dokumentu": "",
        "wersji zaakceptowanej": "",
        "Wersjonowany": "",
        "Wewnętrznie": "",
        "Wiadomości": "",
        "Wiadomość": "",
        "Wiadomość testowa została wysłana.": "",
        "Wiadomość została przywrócona.": "",
        "Wiadomość została ukryta.": "",
        "Wideo": "",
        "Wideo nie jest jeszcze nigdzie opublikowane.": "",
        "Wideo nie ma ustawionej daty publikacji.": "",
        "Wideo premium": "",
        "Wideo z biblioteki": "",
        "Wideo zewnętrzne (URL)": "",
        "Wideo zostało dodane.": "",
        "Wideo zostało usunięte.": "",
        "Wideo zostało zaktualizowane.": "",
        "Widgety": "",
        "Widoczna dla wszystkich użytkowników": "",
        "Widoczność": "",
        "Widoczność konta": "",
        "Widoczność modułu w menu": "",
        "Widoczność sekcji w menu modułu": "",
        "Widoczny obszar": "",
        "Widok czołówki - zdjęcie z tytułem": "",
        "Wielkość kroku": "",
        "Wielokrotnego wyboru": "",
        "Wielokrotny wybór": "",
        "Wiersz": "",
        "Wiersz ${error.actualRow}: błąd w kolumnie ${error.columnName} - ${error.error}": "",
        "Więcej": "",
        "więcej...": "",
        "Więcej...": "",
        "Witryna": "",
        "Witryna / Wersja językowa": "",
        "Witryna aktywna": "",
        "Witryna domyślna": "",
        "Witryna i język": "",
        "Witryna internetowa": "",
        "Witryna tylko dla zalogowanych użytkowników": "",
        "Witryna została dodana.": "",
        "Witryna została usunięta.": "",
        "Witryna została zaktualizowana.": "",
        "Witryny": "",
        "Wklej komponent": "",
        "Właściwości": "",
        "Właściwości szablonu": "",
        "Właściwość '%0' aktywnego wpisu": "",
        "Włącz": "",
        "Włącz ankietę": "",
        "Włącz anonimizację": "",
        "Włącz chat": "",
        "Włącz formularz kontaktowy": "",
        "Włącz monitorowanie aktywności": "",
        "Włącz przynajmniej jedną wersję językową dla witryny aby rozpocząć zarządzanie stronami.": "",
        "Włącz przyznawanie punktów": "",
        "Włącz social media": "",
        "Włącz system komentarzy": "",
        "Włącz walidację po stronie API": "",
        "Włącza bardzo restrykcyjne sprawdzanie typów MIME dla wysyłanych plików. W przypadku zgłaszania błędów dla plików, których zawartości jesteśmy pewni, należy tą opcję pozostawić nieaktywną.": "",
        "Włączenie cykliczności spowoduje usunięcie dat dostępu dla użytkowników i zespołów": "",
        "Włączenie generowania pliku sitemap.xml dla całej witryny": "",
        "Włączenie moderacji danych wejściowych jest zalecane.": "",
        "Włączenie obsługi cacheu dla witryny": "",
        "Włączenie protokołu SSL dla tej witryny": "",
        "Włączona": "",
        "Włączone": "",
        "Włączone (Follow)": "",
        "Włączone (Index)": "",
        "Włączony": "",
        "Województwo": "",
        "Wpis do kalendarza został usunięty.": "",
        "Wpis domyślny": "",
        "Wpis został dodany.": "",
        "Wpis został usunięty": "",
        "Wpis został usunięty.": "",
        "Wpis został zaakceptowany.": "",
        "Wpis został zaktualizowany.": "",
        "Wpisz adresy po przecinku.": "",
        "Wpisz wiadomość": "",
        "Wprowadzamy URL do seriwsów które chemy wykluczyć. Dane mogą być odzielone przecinkiem lub być w nowej linii": "",
        "Wprowadzenie zmian w polu \"Wybierz paczkę SCORM\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmian w polu \"Źródło\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmian w zakładce \"ZAWARTOŚĆ\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzenie zmiany linku powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wróć do logowania": "",
        "Wróć do strony głównej": "",
        "wrzesień": "",
        "Wrzesień": "",
        "wrześniu": "",
        "Wskazuje robotom wyszukiwarek czy mają indeksować stronę.": "",
        "Wskazuje robotom wyszukiwarek czy mają podążać za linkami.": "",
        "Wskazuje, jak długo odpowiedź pozostaje aktualna w pamięci serwera Redis.": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw kontrolkę": "",
        "Wstaw stronę": "",
        "Wstaw szablon informacyjny ze zdjęciem": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wstaw z dołu": "",
        "Wstaw z góry": "",
        "Wstaw z lewej strony": "",
        "Wstaw z prawej strony": "",
        "Wstecz": "",
        "Wstęp": "",
        "Wstępne filtrowanie danych": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!nnCzy na pewno chcesz wykonać akcję??": "",
        "Wszystkie kategorie": "",
        "Wszystkie typy": "",
        "Wszystko": "",
        "Wtorek": "",
        "Wybieranie katalogu jest wymagane": "",
        "wybierz": "",
        "Wybierz": "",
        "Wybierz adres kanoniczny z listy lub podaj ręcznie.": "",
        "Wybierz aktywność": "",
        "Wybierz ankietę": "",
        "Wybierz ankietę do wypełnienia po szkoleniu": "",
        "Wybierz ankietę do wypełnienia przed szkoleniem": "",
        "Wybierz artykuł": "",
        "wybierz asystenta": "",
        "Wybierz autora": "",
        "Wybierz blok": "",
        "Wybierz certyfikat": "",
        "Wybierz czołówkę": "",
        "Wybierz datę": "",
        "Wybierz datę lub wprowadź wartość tekstową": "",
        "wybierz długość": "",
        "Wybierz długość generowanej treści.": "",
        "Wybierz domyślną kategorię": "",
        "Wybierz dostępne pliki": "",
        "Wybierz element": "",
        "Wybierz etykiety produktów": "",
        "Wybierz formularz": "",
        "Wybierz formularz zawierający dodatkowe pola dla kont użytkownków": "",
        "Wybierz galerię": "",
        "Wybierz głównego asystena dla panelu administracyjnego.": "",
        "Wybierz istniejącego użytkownika": "",
        "wybierz katalog": "",
        "Wybierz katalog": "",
        "Wybierz katalog do którego chcesz przenieść wybrane elementy.": "",
        "Wybierz kategorię": "",
        "Wybierz kategorię subskrypcji": "",
        "Wybierz link z serwisu": "",
        "Wybierz listę regulaminów": "",
        "wybierz model": "",
        "Wybierz nowe pliki z komputera": "",
        "Wybierz opcję": "",
        "Wybierz paczkę": "",
        "Wybierz paczkę SCORM": "",
        "Wybierz plik": "",
        "Wybierz plik lub katalog": "",
        "Wybierz plik.": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz produkt": "",
        "Wybierz przełożonego": "",
        "Wybierz regulamin": "",
        "Wybierz rok: ": "",
        "Wybierz rozmiar": "",
        "Wybierz sekcję": "",
        "Wybierz serwer": "",
        "Wybierz shortcode": "",
        "Wybierz stronę": "",
        "Wybierz strony": "",
        "wybierz szablon": "",
        "Wybierz szkolenie": "",
        "Wybierz szkolenie ze ścieżki szkoleniowej": "",
        "Wybierz temat": "",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "",
        "Wybierz typy pytań z jakich będą tworzone testy": "",
        "Wybierz użytkownika": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz wątek w którym chcesz prowadzić konwersację.": "",
        "wybierz wersję": "",
        "Wybierz wersję": "",
        "Wybierz wideo": "",
        "Wybierz wydarzenie": "",
        "Wybierz wydział": "",
        "Wybierz z listy": "",
        "Wybierz zaznaczone": "",
        "wybierz...": "",
        "Wybierz...": "",
        "Wybór": "",
        "Wybór języka": "",
        "Wybór kategorii": "",
        "Wybór kategorii wydarzeń": "",
        "Wybór listy stron": "",
        "Wybór możliwy po zapisaniu zmian w teście.": "",
        "Wybór strony": "",
        "Wybór strony przekierowującej": "",
        "Wybór+": "",
        "Wybrana data jest mniejsza niż dozwolona %0.": "",
        "Wybrana data jest większa niż dozwolona %0.": "",
        "Wybrana ikona powinna być kwadratem": "",
        "Wybrana ikona powinna być kwadratem.": "",
        "Wybrana liczba jest mniejsza niż dozwolona %0.": "",
        "Wybrana liczba jest większa niż dozwolona %0.": "",
        "Wybrana wersja slajdu została wygenerowana w nieprawidłowym formacie. Nie można jej wyświetlić.": "",
        "Wybrane": "",
        "Wybrane dokumenty": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały usunięte.": "",
        "wybrane elementy?": "",
        "Wybrane kategorie": "",
        "Wybrane pliki": "",
        "Wybrane pliki: {0}": "",
        "Wybrane regulaminy:": "",
        "Wybrane spotkanie nie jest opublikowane": "",
        "Wybrane szkolenie nie jest opublikowane": "",
        "Wybrane wydarzenie nie jest opublikowane": "",
        "Wybrane wydarzenie nie ma włączonej opcji \"Wydarzenie dostępne tylko w module spotkań\"": "",
        "Wybrane: %0": "",
        "wybranego elementu": "",
        "Wybranie ankiety jest wymagane": "",
        "Wybranie ikony jest wymagane.": "",
        "Wybranie katalogu jest wymagane": "",
        "Wybranie statusu jest wymagane.": "",
        "Wybranie strony jest wymagane": "",
        "Wybrano": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano dostawcę Azure AI.": "",
        "Wybrano dostawcę Azure OpenAI.": "",
        "Wybrano dostawcę OpenAI.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrany certyfikat jest już nieaktualny.": "",
        "Wybrany element został usunięty.": "",
        "wybrany element?": "",
        "Wybrany materiał został już dodany do lekcji": "",
        "Wybrany materiał został już dodany do testu": "",
        "Wybrany szablon": "",
        "Wybrany wydział został już dodany do zespołu.": "",
        "Wybrany znak zastąpi znacznik separatora | wstawiony w tytule.": "",
        "wybranych elementów": "",
        "Wybróbuj możliwości AI": "",
        "Wyczyszczenie pamięci podręcznej może spowodować usunięcie niezapisanych postępów czasu spędzonego na platformie.": "",
        "Wyczyść": "",
        "Wyczyść aranżację": "",
        "Wyczyść pamięć podręczną": "",
        "Wyczyść wybór": "",
        "Wydarzenie dostępne tylko w module spotkań": "",
        "Wydarzenie z kalendarza": "",
        "Wydział": "",
        "Wydziały": "",
        "Wygenerowana odpowiedź przez model AI.": "",
        "Wygenerowane obrazy": "",
        "Wygenerowane szkolenie znajdziesz ": "",
        "Wygeneruj metadane dla przesyłanych obrazów": "",
        "Wygląd": "",
        "Wyklucz logowanie zależności": "",
        "Wykonaj": "",
        "Wykonawca": "",
        "Wykonuje się": "",
        "Wykorzystane": "",
        "Wykresy": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "Wyłaczone": "",
        "Wyłącz komentarze": "",
        "Wyłącz udostępnij dalej": "",
        "Wyłączone (NoFollow)": "",
        "Wyłączone (NoIndex)": "",
        "Wyłączone komentarze": "",
        "Wyłączone udostępnianie": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wyłączony": "",
        "Wymaga autoryzacji": "",
        "Wymaga potwierdzenia": "",
        "Wymagaj kolejności zaliczania elementów": "",
        "Wymagaj odpowiedzi, aby przejść dalej": "",
        "Wymagaj pełnego odsłuchania do zaliczenia": "",
        "Wymagaj pełnego odsłuchania/obejrzenia do zaliczenia": "",
        "Wymagaj ponownej akceptacji po zmianach": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagane": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymagane jest wybranie formularza": "",
        "Wymagane jest wybranie kategorii": "",
        "Wymagane jest wybranie komponentu": "",
        "Wymagane jest wybranie modułu": "",
        "Wymagane jest wybranie sekcji": "",
        "Wymagane jest wybranie wersji językowej": "",
        "Wymagane jest wybranie witryny": "",
        "Wymagane jest wybranie zestawu regulaminów": "",
        "Wymagane jest wybranie źródła": "",
        "Wymagane jest wybranie źródła danych": "",
        "Wymagane znaki": "",
        "wymagany": "",
        "Wymagany procent musi zawierać się w przedziale 0-100": "",
        "Wymiary": "",
        "Wymuś nowe podejście - reset wyniku": "",
        "Wymuś zmianę hasła": "",
        "Wynik": "",
        "Wynik (%)": "",
        "Wynik etapu jest wymagany": "",
        "Wynik testu": "",
        "Wyniki": "",
        "Wyniki testu zawszę będą ograniczone do maksymalnie 10 pozycji.": "",
        "Wyniki_": "",
        "Wypełnij pozycje": "",
        "Wypełnij treści zakładek": "",
        "Wyrażenia warunkowe": "",
        "Wyrażenie regularne": "",
        "Wyrażenie w postaci \"/pattern/flag\" nie jest obsługiwane, użyj same wartości pattern": "",
        "Wyrażone zgody": "",
        "Wysłane": "",
        "Wysoka szczegółowość": "",
        "Wysoki": "",
        "Wysokość": "",
        "Wysokość [px": "",
        "Wystapił błąd podczas kopiwaniu linku.": "",
        "wystąpieniach": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby exportu zamówień.": "",
        "Wystąpił błąd podczas próby exportu.": "",
        "Wystąpił błąd podczas próby importu definicji modułu.": "",
        "Wystąpił błąd podczas próby importu przekierowań.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd podczas próby pobrania szablonu.": "",
        "Wystąpił błąd podczas próby pobrania szczegółów.": "",
        "Wystąpił błąd podczas przełączania się między wątkami.": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił błąd. Nie udało się zmienić statusu.": "",
        "Wystąpił błąd. Spróbuj ponownie później.": "",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił problem podczas przesyłania obrazu.": "",
        "Wystąpił problem z pobraniem certyfikatu": "",
        "Wystąpił problem z pobraniem wiadomości.": "",
        "Wystąpił problem z potwierdzeniem obecności": "",
        "Wystąpił problem z usunieciem wątku.": "",
        "Wystąpiły błędy podczas zapisywania formularza": "",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "",
        "Wysyłaj dane o użytkowniku": "",
        "Wysyłaj tym kanałem": "",
        "Wyszukaj": "",
        "Wyszukaj (Ctrl+Q)": "",
        "Wyszukaj albo dodaj nową kategorię": "",
        "Wyszukaj albo dodaj nowy tag": "",
        "Wyszukaj autora...": "",
        "Wyszukaj blok": "",
        "Wyszukaj czołówkę...": "",
        "Wyszukaj formularz...": "",
        "Wyszukaj kategorię": "",
        "Wyszukaj produkt...": "",
        "Wyszukaj regulamin...": "",
        "Wyszukaj szkolenie...": "",
        "Wyszukaj użytkownika": "",
        "wyszukaj użytkownika...": "",
        "Wyszukaj użytkownika...": "",
        "Wyszukaj widget": "",
        "Wyszukaj wszędzie": "",
        "Wyszukaj zespół": "",
        "Wyszukaj...": "",
        "Wyszukiwanie": "",
        "Wyszukiwanie plików": "",
        "Wyszukiwanie plików umożliwia asystentowi korzystanie z wiedzy z plików. Po przesłaniu pliku asystent automatycznie decyduje, kiedy pobrać treść, na podstawie żądań użytkownika.": "",
        "Wyszukiwanie zwraca tylko zaakceptowane wersje regulaminów": "",
        "Wyszukiwany ciąg znaków": "",
        "Wyszukiwarka włączona": "",
        "Wyszukiwarka wyłączona": "",
        "Wyślij": "",
        "Wyślij do": "",
        "Wyślij kod": "",
        "Wyślij wiadomość": "",
        "Wyświetl materiały": "",
        "Wyświetl popup z kontynuacją lekcji": "",
        "Wyświetl w ulubionych": "",
        "Wyświetlaj artykuł na całą stronę": "",
        "Wyświetlaj listę artykułów z miniaturką zdjęcia": "",
        "Wyświetlaj nazwę bloczka": "",
        "Wyświetlaj opinie z tłem": "",
        "Wyświetlaj tylko treść": "",
        "Wyświetlaj tytuł": "",
        "Wyświetlam": "",
        "Wyświetlanie": "",
        "Wyświetlanie dokumentów": "",
        "Wyświetlany układ / dane": "",
        "Wytnij": "",
        "Wytyczne dla Kreatora szkoleń": "",
        "Wytyczne dotyczące tworzenia szkoleń w kreatorze AI": "",
        "Wywołanie funkcji": "",
        "Wyzeruj licznik": "",
        "Wyzwalacze": "",
        "Wyżej": "",
        "Wzorzec": "",
        "Wzorzec cyklu": "",
        "YouTube (ID)": "",
        "z maksymalnie 240 znaków": "",
        "z maksymalnie 580 znaków": "",
        "Z uprawnieniami": "",
        "Z uprawnieniami do modułu": "",
        "Zaakceptowane": "",
        "Zaakceptowany": "",
        "Zaawansowane": "",
        "Zaawansowane polecenia": "",
        "Zaawansowane uprawnienia": "",
        "Zaawansowany edytor tekstu": "",
        "Zabierz dostęp": "",
        "Zablokowany": "",
        "Zablokuj": "",
        "Zablokuj użytkownika": "",
        "Zachowaj oryginalny format obrazów": "",
        "zacznij pisać aby wyszukać ankietę...": "",
        "zacznij pisać aby wyszukać ankiety...": "",
        "zacznij pisać aby wyszukać artykuł...": "",
        "zacznij pisać aby wyszukać autora...": "",
        "zacznij pisać aby wyszukać certyfikat...": "",
        "zacznij pisać aby wyszukać galerię...": "",
        "zacznij pisać aby wyszukać kategorię...": "",
        "zacznij pisać aby wyszukać materiał...": "",
        "zacznij pisać aby wyszukać paczkę SCORM...": "",
        "zacznij pisać aby wyszukać produkt...": "",
        "zacznij pisać aby wyszukać przełożonego...": "",
        "zacznij pisać aby wyszukać rotator...": "",
        "zacznij pisać aby wyszukać slajder...": "",
        "zacznij pisać aby wyszukać spotkanie...": "",
        "zacznij pisać aby wyszukać szkolenie...": "",
        "zacznij pisać aby wyszukać użytkownika...": "",
        "zacznij pisać aby wyszukać wideo...": "",
        "zacznij pisać aby wyszukać wydarzenie...": "",
        "zacznij pisać aby wyszukać wydział...": "",
        "zacznij pisać aby wyszukać zespół...": "",
        "zacznij pisać aby wyszukać...": "",
        "Zacznij pisać Form lub Entry aby uruchomić podpowiadanie.": "",
        "Zaczyna sie od": "",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Zagrożenie": "",
        "Zaimportowano definicję modułu.": "",
        "Zaimportowano listę przekierowań.": "",
        "Zaimportowano listę użytkowników.": "",
        "Zajawka": "",
        "Zakładka ": "",
        "Zakładki": "",
        "Zakolejkowane": "",
        "Zakończ edycje": "",
        "Zakończ sesję": "",
        "Zakończ sesję aby wylogować użytkownika": "",
        "Zakończenie spotkania": "",
        "Zakończenie szkolenia": "",
        "Zakończenie zapisów": "",
        "Zakończone": "",
        "Zakończony": "",
        "zakończy się porażką": "",
        "zakończy się sukcesem": "",
        "Zakończyło": "",
        "Zakres": "",
        "Zakres cyklu": "",
        "Zakres czasu": "",
        "Zaktualizowano pliki Kreatora szkoleń": "",
        "Zaktualizowano wątek.": "",
        "Zaktualizowano.": "",
        "Zaktualizuj formularz": "",
        "Zaktualizuj najnowszą wersję dokumentu": "",
        "Zalecane wymiary 1605x450": "",
        "Zależna od kontrolki": "",
        "Zaliczenie": "",
        "Zaliczenie testu": "",
        "Zaliczenie testu jest równoznaczne z potwierdzeniem obecności i wystawieniem certyfikatu dla użytkownika": "",
        "Zaliczone": "",
        "Zaliczono wszystkie elementy szkolenia.": "",
        "Zaliczono wybrane elementy szkolenia.": "",
        "Zaliczony": "",
        "Zalogowany": "",
        "Zaloguj się": "",
        "Zaloguj się na swoje konto": "",
        "Załączniki": "",
        "Załączniki premium": "",
        "Zamawiający": "",
        "Zamiany zostały zapisane.": "",
        "Zamknij": "",
        "Zamknij i pobierz": "",
        "Zamówienia": "",
        "Zamówienie": "",
        "Zamówienie zostało dodane.": "",
        "Zamówienie zostało zaktualizowane.": "",
        "Zamykaj wcześniej otwarte pozycje": "",
        "Zaokraglone rogi [px": "",
        "Zaokrąglenie": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane urządzenia": "",
        "Zapis nowej wersji elementu szkolenia": "",
        "Zapis został usunięty": "",
        "Zapisani": "",
        "Zapisuj do celu": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisz": "",
        "Zapisz aranżację": "",
        "Zapisz filtr": "",
        "Zapisz i wróć": "",
        "Zapisz i wyślij": "",
        "Zapisz i zamknij": "",
        "Zapisz lekcję": "",
        "Zapisz lekcję scorm": "",
        "Zapisz lekcję scorm w nowej wersji": "",
        "Zapisz lekcję w nowej wersji": "",
        "Zapisz lekcję wideo": "",
        "Zapisz lekcję wideo w nowej wersji": "",
        "Zapisz link": "",
        "Zapisz link w nowej wersji": "",
        "Zapisz pozycje": "",
        "Zapisz slajd": "",
        "Zapisz ścieżkę aby móc ją opublikować.": "",
        "Zapisz temat": "",
        "Zapisz test": "",
        "Zapisz test w nowej wersji": "",
        "Zapisz ustawienia": "",
        "Zapisz ustawienia widgetów": "",
        "Zapisz widget": "",
        "Zapisz wybrane": "",
        "Zapisz zmiany": "",
        "Zaplanowane": "",
        "Zapomniałeś hasła?": "",
        "Zapytaj asystenta": "",
        "Zapytanie": "",
        "Zapytanie SQL do pobrania po ID": "",
        "Zapytanie SQL do wyszukiwania": "",
        "Zarchiwizowane": "",
        "Zarządzaj zespołami": "",
        "Zarządzanie witrynami": "",
        "Zarządzanie zespołami": "",
        "Zasięg": "",
        "Zastępstwa": "",
        "Zastępstwo": "",
        "Zastępstwo wygasło.": "",
        "Zastępstwo wygaśnie za 10 minut.": "",
        "Zastępstwo wygaśnie za 5 minut.": "",
        "Zastępstwo wygaśnie za minutę.": "",
        "Zastępstwo zostało dodane.": "",
        "Zastępstwo zostało usunięte.": "",
        "Zastępstwo zostało zaktualizowane.": "",
        "Zastępuje osobę": "",
        "Zastosuj zmiany w aplikacji": "",
        "Zatwierdź": "",
        "Zaufane adresy IP": "",
        "Zawartość": "",
        "Zawiera": "",
        "Zawiera sekcje": "",
        "Zawierające jeden z wybranych tagów": "",
        "Zawsze": "",
        "Zaznacz": "",
        "Zaznacz wszystkie": "",
        "Zaznacz/odznacz wszystko": "",
        "Zbieranie i przechowywanie logów": "",
        "Zbliżająca się data zakończenia": "",
        "Zdarzenie": "",
        "Zdjęcia": "",
        "Zdjęcie": "",
        "Zdjęcie autora": "",
        "Zdjęcie dla tabletów": "",
        "Zdjęcie dla urządzeń mobilnych": "",
        "Zdjęcie główne": "",
        "Zdjęcie użytkownika": "",
        "Zdjęcie w tle": "",
        "Zespoły": "",
        "Zespół": "",
        "Zespół aktywny": "",
        "Zespół został dodany.": "",
        "Zespół został przypisany do szkolenia.": "",
        "Zespół został przypisany do ścieżki szkoleniowej.": "",
        "Zespół został przypisany do terminu.": "",
        "Zespół został usunięty.": "",
        "Zespół został zaktualizowany.": "",
        "Zestaw": "",
        "Zestaw niestandardowy": "",
        "Zestaw został dodany.": "",
        "Zestaw został zaktualizowany.": "",
        "Zewnętrzne skrypty statystyk": "",
        "Zewnętrzne skrypty targetujące": "",
        "Zewnętrzny link jest wymagany": "",
        "Zewnętrzny serwis": "",
        "Zgłaszanie komentarzy": "",
        "Zgłoszenia": "",
        "Zgoda": "",
        "Zielony": "",
        "Zliczanie": "",
        "Zmiana hasła": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!nnCzy na pewno chcesz zapisać zmiany??": "",
        "Zmiana wersji elementu nie dotyczy użytkowników z zakończonym szkoleniem": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "",
        "Zmiany zostały zapisane.": "",
        "Zmiany zostaną zastosowane w aplikacji w przeciągu kikunastu sekund": "",
        "Zmieną %HEAD_TITLE% można wykorzystać w innych polach tekstowych.": "",
        "Zmieniono ustawienia widgetu": "",
        "Zmienna": "",
        "Zmienna musi się zaczynać od małej litery i może zawierać tylko znaki alfanumeryczne": "",
        "Zmień daty publikacji": "",
        "Zmień hasło": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień rozmiar": "",
        "Zmień status": "",
        "Zmień status edytowanej wersji": "",
        "Zmień widok": "",
        "Zmniejsz": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "zmodyfikowany": "",
        "Znajdź typ bloku...": "",
        "znaki": "",
        "Znaki specialne": "",
        "Zobacz przed opublikowaniem": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Zobacz wszystkie": "",
        "Zobacz wszystkie zastępstwa": "",
        "Został przywrócony oryginalny harmonogram": "",
        "został wysłany": "",
        "Zostaną zaktualizowane definicje wszystkich dokumentów.": "",
        "Zrealizowane": "",
        "Zresetowano podejście.": "",
        "Zresetuj hasło": "",
        "zresetuj podejście do elementu szkolenia": "",
        "Zrestartuj aplikacje": "",
        "Zrezygnowano z subskrypcji": "",
        "Zużyte tokeny": "",
        "Zwrócony": "",
        "Zwykłe": "",
        "Źródła danych": "",
        "Źródła LDAP": "",
        "Źródła logów": "",
        "Źródło": "",
        "Źródło aktywne": "",
        "Źródło danych": "",
        "źródło danych zostało dodane.": "",
        "Źródło danych zostało zaktualizowane.": "",
        "Źródło LDAP zostało dodane.": "",
        "Źródło LDAP zostało zaktualizowane.": "",
        "Źródło URL": "",
        "źródło zostało usunięte.": "",
        "Źródło zostało usunięte.": "",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "",
        "Żółty": "",
        "Żródło danych": ""
    }
};
